const translations = {
  accept: "Accept",
  acceptInterest: "Accept interest",
  account: "Account",
  accountCreated: "Account created",
  actions: "Actions",
  "activity.by": "by {{ displayName }}",
  "activity.CollectionCreated": "{{ title }} created",
  "activity.CollectionDeleted": "{{ title }} deleted",
  "activity.CrewMembershipCreated": "{{ title }} created",
  "activity.CrewMembershipDeleted": "{{ title }} deleted",
  "activity.CrewMembershipWithdrawn": "{{ title }} withdraw",
  "activity.HistoryRecordCreated": "{{ title }} recorded",
  "activity.HistoryRecordDeleted": "{{ title }} deleted",
  "activity.HistoryRecordRecovered": "{{ title }} recovered",
  "activity.ListingCreated": "{{ title }} created",
  "activity.LocationCreated": "{{ title }} created",
  "activity.LocationDeleted": "{{ title }} deleted",
  "activity.NegotiationCreated": "{{ title }} created",
  "activity.NegotiationStatusUpdated": "{{ title }} status updated",
  "activity.VehicleCollectionsUpdated": "{{ title }} collections updated",
  "activity.VehicleConsignmentUpdated": "{{ title }} consignment updated",
  "activity.VehicleConsignmentUpdated.movedFromTo":
    "{{ title }} consignment updated from <fromLink>{{ from }}</fromLink> to <toLink>{{ to }}</toLink>",
  "activity.VehicleConsignmentUpdated.movedTo":
    "{{ title }} consignment updated to <toLink>{{ to }}</toLink>",
  "activity.VehicleConsignmentUpdated.removedFrom":
    "{{ title }} consignment removed from <fromLink>{{ from }}</fromLink>",
  "activity.VehicleCreated": "{{ title }} created",
  "activity.VehicleDeleted": "{{ title }} deleted",
  "activity.VehicleLocationUpdated": "{{ title }} location updated",
  "activity.VehicleLocationUpdated.movedFromTo":
    "{{ title }} location updated from <fromLink>{{ from }}</fromLink> to <toLink>{{ to }}</toLink>",
  "activity.VehicleLocationUpdated.movedTo":
    "{{ title }} location updated to <toLink>{{ to }}</toLink>",
  "activity.VehicleLocationUpdated.removedFrom":
    "{{ title }} location removed from <fromLink>{{ from }}</fromLink>",
  "activity.VehicleRecovered": "{{ title }} recovered",
  "activity.VehicleSpecsUpdated": "{{ title }} specs updated",
  "activity.VehicleTechnicalDataUpdated": "{{ title }} technical data updated",
  "activity.VehicleVehicleDataUpdated": "{{ title }} data updated",
  add: "Add",
  addACollection: "Add a collection",
  addACollector: "Add a collector",
  addALocation: "Add a location",
  addARecord: "Add a record",
  addAService: "Add a service",
  addAVehicle: "Add a vehicle",
  addDataRoom: "Add a Data Room",
  addNewCredential: "Add new device",
  addPhotosAndVideos: "Add photos & videos",
  addPhotosVideosDescription:
    "There are no photos or videos for this {{entityType}} at the moment.",
  addReminder: "Add reminder",
  address: "Address",
  addressNotFound: "Address not found",
  addSpecs: "Add specifications",
  addSpecsToSection:
    "There are no specifications for this section at the moment.",
  addTag: "Add tag",
  addThisVehicle: "Add this vehicle",
  addToWishlist: "Add to wishlist",
  addVehiclesToCollection: "Add vehicles to collection",
  addVehiclesToLocation: "Add vehicles to location",
  addVideoOrModelByUrl: "Add video or 3D model by URL",
  addVideoOrModelSupportedProviders:
    "Supported providers: YouTube, Vimeo for videos and Matterport for 3D models",
  "admin.customer": "customer",
  "alert.curating.button.stop": "Finish",
  "alert.curating.title": 'Curating profile "<strong>{{username}}</strong>"',
  amount: "Amount",
  andNMore: "{{entity}} and {{count}} more",
  appTheme: "App theme",
  "appTheme.acme": "ACME",
  "appTheme.ascari": "Ascari",
  "appTheme.bi": "B.I. COLLECTR",
  "appTheme.curated": "CURATED",
  "appTheme.dark": "Driven - Dark",
  "appTheme.driven": "Driven",
  "appTheme.ilr": "ILR",
  "appTheme.kessel": "Kessel",
  "appTheme.light": "Driven - Light",
  archived: "Archived",
  autocompleteHint: "Type to create new",
  avatar: "Avatar",
  back: "Back",
  batch: "Batch",
  becomeMember: "Become a member",
  billing: "Billing",
  "billing.saved": "Saved payment methods",
  "billing.selected": "Selected payment method",
  bio: "Bio",
  cancel: "Cancel",
  cancelSubscription: "Cancel subscription",
  cannotDeleteIfPartOfVerificationProcess:
    "This file is part of a verification process. You cannot delete it.",
  cannotListVehicleAlreadyListed: "Vehicle is already listed on transactions.",
  cannotListVehicleNotSubscribed:
    "You have to be subscribed in order to list vehicles on transactions.",
  cannotListVehicleOverQuota:
    "You have reached the limit of Data Rooms for your current subscription.",
  cannotListVehicleReadOnly: "You cannot list this vehicle.",
  car: "Car",
  changeEmail: "Change email",
  changePassword: "Change password",
  changePaymentMethod: "Change payment method",
  chassisNumber: "VIN or chassis number",
  clearAllFilters: "Clear all filters",
  close: "Close",
  collection: "Collection",
  "collection.count_one": "{{count}} collection",
  "collection.count_other": "{{count}} collections",
  "collection.step.pickVehicles.selected": "You have selected",
  collectionNotFound: "Collection not found",
  collections: "Collections",
  collectorNotFound: "Collector not found",
  concierge: "Concierge",
  condition: "Condition",
  "condition.average": "Average",
  "condition.clean": "Clean",
  "condition.damaged": "Damaged",
  "condition.description.average":
    "May have a few mechanical and/or cosmetic problems and may require a considerable amount of reconditioning.",
  "condition.description.clean":
    "Some normal wear but no major mechanical or cosmetic problems; may require limited reconditioning.",
  "condition.description.damaged":
    "Major mechanical and/or body damage that may render it in non-safe running condition.",
  "condition.description.outstanding":
    "Exceptional mechanical, exterior and interior condition; requires no reconditioning.",
  "condition.description.rough":
    "Several mechanical and/or cosmetic problems requiring significant repairs.",
  "condition.help": "Edmunds conditions help",
  "condition.outstanding": "Outstanding",
  "condition.rough": "Rough",
  confirm: "Confirm",
  confirmedPassword: "Confirm your password",
  confirmEmailAlert:
    "Confirm your email, check your inbox or spam folder for a message from Driven with a secure link",
  confirmMfaAuthAppClaim:
    "Please, introduce the 6-digit code <br /> that appears in your <strong>authenticator app</strong>",
  confirmMfaClaim: "Please, introduce the 6-digit code {{methodClaim}}",
  confirmMfaEmailClaim:
    "Please, introduce the 6-digit code <br /> sent to your <strong>email</strong>",
  confirmMfaWebAuthnClaim:
    "Connect your preferred <strong>device or USB-Key</strong> to start the verification process",
  "consent.approve": "Approve",
  "consent.clientRequesting":
    "<strong>{{clientName}}</strong> is requesting access to your data.",
  "consent.dataAccess": "The client will be able to access the following data:",
  "consent.deny": "Deny",
  "consent.invalidRequest": "Invalid request. Please contact support.",
  "consent.warning":
    "Please ensure that you trust the client before granting access.",
  consentTerms:
    "I have read the <1>Privacy Policy</1> and accept the <3>Terms and Conditions</3>",
  consignment: "Consignment",
  contactDriven: "Contact Driven",
  continue: "continue",
  cookiePolicy: "Cookie Policy",
  copyDataRoomLink: "Copy Data Room link",
  copyLink: "Copy link",
  copyPrivateLink: "Copy private link",
  copyright: "© {{year}} Driven AG. All rights reserved.",
  copySandboxLink: "Copy Sandbox link",
  "copySandboxLink.tooltip":
    "Save (or share) this link to access this sandbox until {{expirationDate}}",
  copyVehicleViewOnlyLink: "Copy vehicle view only link",
  country: "Country",
  create: "Create",
  created: "Created",
  createNewCollection: "Create new collection",
  createNewLocation: "Create new location",
  currency: "Currency",
  currencyRequired: "Currency is required",
  currentTierExpirationDate: "Current tier expiration date",
  customizeLayout: "Customize layout",
  "dashboard.total": "Total value of assets",
  "dashboard.viewAllActivity": "View all activity",
  "dataRoom.group": "Group",
  "dataRoom.guest": "Inspect",
  "dataRoom.guest.empty": "You are not invited to any Data Rooms yet",
  "dataRoom.manage": "Manage",
  "dataRoom.manage.create": "Create Data Room",
  "dataRoom.manage.empty": "You have not created any Data Rooms yet",
  "dataRoom.manage.publicTitle": "Public title",
  "dataRoom.manage.publicTitle.description":
    "Public title is visible to the people you invite.",
  "dataRoom.memberships.manage": "Memberships",
  "dataRoom.memberships.manage.emptyState.content": "Invite new members",
  "dataRoom.memberships.manage.invite": "Invite",
  "dataRoom.permissions.manage": "Permissions",
  "dataRoom.permissions.noData":
    "This vehicle has no Vault files or Log Book records to share",
  "dataRoom.permissions.section.filesAssignedToLogbookRecord":
    "Files assigned to Log Book record",
  "dataRoom.permissions.section.filesNotRelatedToLogbookRecord":
    "Files not related to Log Book record",
  "dataRoom.permissions.subtitle":
    "Select which Log Book records the group has access to (market values associated with Log Book records are not shared)",
  date: "Date",
  dateDeleted: "Date deleted",
  dateRegistered: "Date registered",
  dateUploaded: "Date uploaded",
  decrypt: "Decrypt",
  default: "Default",
  delete: "Delete",
  deleteAccount: "Delete account",
  deleteFile: "Delete file",
  deleteVehicle: "Delete vehicle",
  delisted: "Delisted",
  delistVehicle: "Delist vehicle",
  "density.grid": "Grid",
  "density.list": "List",
  "density.map": "Map",
  "density.timeline": "Timeline",
  description: "Description",
  "description.empty.readonly": "No description provided",
  "description.generate": "Generate using AI",
  "dialog.avatar.content":
    "You can resize the image and select a specific area.",
  "dialog.avatar.title": "Avatar",
  "dialog.billingMethod.add.confirmButton": "Add payment method",
  "dialog.billingMethod.add.content":
    "Introduce the details of the payment method you would like to use on Driven",
  "dialog.billingMethod.add.title": "Add new payment method",
  "dialog.billingMethod.remove.confirmButton": "Delete payment method",
  "dialog.billingMethod.remove.content":
    "You are about to delete <strong>{{card}}</strong>. This will remove this payment method for future purchases.",
  "dialog.billingMethod.remove.title": "Delete payment method",
  "dialog.billingMethod.removeDefault.content":
    "<strong>{{card}}</strong> is your preferred method of payment. Make sure you add or select another payment method to avoid service interruption.",
  "dialog.collection.delete.title": "Delete collection",
  "dialog.collector.remove.content":
    "You are about to remove <strong>{{username}}</strong> from <strong>{{organization}}</strong>. Are you sure about it?",
  "dialog.collector.remove.instructions":
    "Please type <strong>{{confirmationString}}</strong>below to confirm:",
  "dialog.collector.remove.title": "Remove collector from organization",
  "dialog.collector.remove.warning": "This action cannot be undone!",
  "dialog.collector.sendWelcomeEmail": "Send Welcome email",
  "dialog.collector.sendWelcomeEmail.content":
    "Are you sure you want to send the welcome email to <strong>{{username}}</strong>?",
  "dialog.collector.sendWelcomeEmail.userConfirmedWarning":
    "An email invitation has already been sent before and the user is confirmed.",
  "dialog.concierge.promote.content":
    "You are about to promote <strong>{{fullName}}</strong>, are you sure?",
  "dialog.concierge.promote.title": "Promote",
  "dialog.concierge.toggleIsActive.content":
    "You are about to {{operation}} <strong>{{fullName}}</strong>, are you sure about it?",
  "dialog.concierge.toggleIsActive.operation.activate": "Activate",
  "dialog.concierge.toggleIsActive.operation.deactivate": "Deactivate",
  "dialog.confirm.dataRoom.membership.revoke.content":
    "You are about to revoke the <strong>{{membershipTitle}}</strong> membership from <strong>{{dataRoomTitle}}</strong> Data Room. Are you sure about it?",
  "dialog.confirm.dataRoom.membership.revoke.title": "Revoke membership",
  "dialog.confirm.dataRoom.membership.withdraw.content":
    "You are about to withdraw your membership from the <strong>{{dataRoomTitle}}</strong> Data Room. Are you sure about it?",
  "dialog.confirm.dataRoom.membership.withdraw.title": "Withdraw membership",
  "dialog.confirm.default.2fa":
    "This action requires 2FA confirmation to proceed",
  "dialog.confirm.default.button.cancel": "Cancel",
  "dialog.confirm.default.button.confirm": "Confirm",
  "dialog.confirm.default.confirmationKeywordInstructions":
    "Please type <strong>{{keyword}}</strong> below to confirm:",
  "dialog.confirm.default.content": "Do you want to proceed?",
  "dialog.confirm.default.irreversibleWarning": "This action cannot be undone!",
  "dialog.confirm.default.title": "Confirm",
  "dialog.confirm.delete.button.confirm": "Yes, delete",
  "dialog.confirm.delete.content": "Do you want to proceed with deletion?",
  "dialog.confirm.delete.content_entity":
    "You are about to delete <strong>{{title}}</strong>, are you sure about it?",
  "dialog.confirm.delete.title": "Delete",
  "dialog.confirm.remove.button.confirm": "Yes, remove",
  "dialog.confirm.remove.content": "Do you want to proceed with removal?",
  "dialog.confirm.remove.content_entity":
    "You are about to remove <strong>{{title}}</strong>, are you sure about it?",
  "dialog.confirm.remove.title": "Remove",
  "dialog.confirm.transfer.button.confirm": "Yes, transfer",
  "dialog.confirm.transfer.content":
    "Do you want to proceed with the transfer?",
  "dialog.confirm.transfer.content_entity":
    "You are about to transfer <strong>{{title}}</strong>, are you sure about it?",
  "dialog.confirm.transfer.title": "Transfer",
  "dialog.confirm.unsavedChanges.button.confirm": "Yes, leave",
  "dialog.confirm.unsavedChanges.content":
    "Changes will be lost, are you sure you want to leave?",
  "dialog.confirm.unsavedChanges.title": "Unsaved changes",
  "dialog.crew.shareInvitationViaEmail.title": "Share invitation via email",
  "dialog.dataRoom.delete.content":
    "You are about to delete the <strong>{{title}}</strong> Data Room, are you sure about it?",
  "dialog.dataRoom.delete.title": "Delete Data Room",
  "dialog.dataRoom.manage.title": "Manage Data Room",
  "dialog.dataRoom.membership.invitation.description":
    "Share this link with {{email}} to invite them to the Data Room",
  "dialog.dataRoom.membership.invitation.title": "{{title}} membership",
  "dialog.dataRoom.membership.invite.submit": "Send invitation",
  "dialog.dataRoom.membership.invite.title": "Invite user",
  "dialog.email.change.subtitle":
    "You will receive a confirmation email to your new address, only after clicking the link on it the change will be effective",
  "dialog.email.change.title": "Change email",
  "dialog.garage.batch.adding": "Adding vehicles",
  "dialog.garage.batch.processing": "Applying AI magic",
  "dialog.garage.batch.uploading": "Uploading file",
  "dialog.garage.empty.content":
    "You don't have any vehicles in your Garage to add to this {{collection}} yet.<br /> Maybe now is a great moment to <strong>upload your first vehicle to your Drive Garage!</strong>",
  "dialog.guard.content":
    "Onboard your own vehicles, manage them, like other vehicles, and interact with fellow collectors and enthusiasts with an account",
  "dialog.guard.login.title": "Login",
  "dialog.guard.mfa.title": "Two-factor authentication (2FA)",
  "dialog.guard.resetPassword.title": "Reset password",
  "dialog.guard.signUp.title": "Sign up",
  "dialog.history.delete.bulk.content":
    "You are about to delete all the selected history record, are you sure about it?",
  "dialog.history.delete.bulk.title": "Delete selected history records",
  "dialog.history.delete.content":
    "You are about to delete the history record from <strong>{{date}}</strong>, are you sure about it?",
  "dialog.history.delete.title": "Delete history record",
  "dialog.history.review.bulk.content":
    "You are about to save all the selected history record drafts, are you sure about it?",
  "dialog.history.review.bulk.title": "Save selected history record drafts",
  "dialog.listing.acceptInterest.button": "Accept interest",
  "dialog.listing.acceptInterest.confirm":
    "Are you sure you want to accept this interest?",
  "dialog.listing.cancelInterest.buyer.button": "Withdraw interest",
  "dialog.listing.cancelInterest.buyer.confirm":
    "Are you sure you want to withdraw your interest?",
  "dialog.listing.cancelInterest.seller.button": "Reject",
  "dialog.listing.cancelInterest.seller.confirm":
    "Are you sure you want to reject this interest?",
  "dialog.listing.completeNegotiation.confirmButton": "Continue",
  "dialog.listing.completeNegotiation.content":
    "You are about to transfer a digital representation of the vehicle to the buyer. You will keep the original in your Garage.",
  "dialog.listing.completeNegotiation.instructions":
    "To confirm your intention, you have to write <strong>‘{{confirmationString}}’</strong> bellow:",
  "dialog.listing.completeNegotiation.title":
    "Complete negotiation and transfer vehicle",
  "dialog.listing.completeNegotiation.warning":
    "This action cannot be undone. The buyer will get a copy of the vehicle, all medias, history records and documents.",
  "dialog.listing.delist.confirmButton": "Yes, delist",
  "dialog.listing.delist.content":
    "You are about to delist <strong>{{vehicleTitle}}</strong>, are you sure about it?",
  "dialog.listing.delist.instructions":
    "Please type <strong>{{confirmationString}}</strong>below to confirm:",
  "dialog.listing.delist.title": "Delist vehicle",
  "dialog.listing.delist.warning":
    "This action cannot be undone and will affect all current negotiations for this vehicle!",
  "dialog.listing.details.content":
    "We care about your privacy, we will list your vehicle anonymously.",
  "dialog.listing.details.title": "Listing details",
  "dialog.listing.selectVehicle.content":
    "We will pre-fill the Data Room with as much information as possible.",
  "dialog.listing.selectVehicle.empty": "No vehicle matching your search",
  "dialog.listing.selectVehicle.title": "Select vehicle",
  "dialog.listing.showInterest.confirmButton": "Continue",
  "dialog.listing.showInterest.content":
    "The seller will need to accept your approach before your start negotiations.",
  "dialog.listing.showInterest.placeholder":
    "A short message to introduce yourself",
  "dialog.listing.showInterest.title": "Show interest for the vehicle",
  "dialog.listView.save.content":
    "You can come back to a column selection by saving a view. Views you save will be available in the Select View panel",
  "dialog.listView.save.title": "Save current view",
  "dialog.location.delete.title": "Delete location",
  "dialog.manageCollectors.title": "Manage assignees",
  "dialog.media.delete.bulk.content":
    "You are about to delete all the selected documents, are you sure about it?",
  "dialog.media.delete.bulk.title": "Delete selected documents",
  "dialog.media.delete.title": "Delete document",
  "dialog.media.edit.tags.helperText":
    "Select a category that matches the document. You can also create your own tag. To rename or delete them go to the <1>Tag Manager</1>.",
  "dialog.media.edit.title": "Edit document",
  "dialog.media.edit.warning": "This action cannot be undone!",
  "dialog.membership.add.confirmButton": "Add",
  "dialog.membership.add.content":
    "Select a new crew member by searching username. Member already has to be registered on Driven.",
  "dialog.membership.add.title": "Add new crew member",
  "dialog.membership.invite.remove.content":
    "You are about to delete the invite, are you sure about it?",
  "dialog.membership.invite.remove.title": "Delete pending invite",
  "dialog.membership.remove.confirmButton": "Remove",
  "dialog.membership.remove.content":
    "You are about to remove <strong>{{username}}</strong> as a member of your crew, are you sure about it?",
  "dialog.membership.remove.title": "Remove member from crew",
  "dialog.membership.withdraw.confirmButton": "Withdraw",
  "dialog.membership.withdraw.content":
    "You are about to withdraw your membership from <strong>{{username}}</strong>'s crew, are you sure about it?",
  "dialog.membership.withdraw.title": "Withdraw membership from crew",
  "dialog.mfa.disable.content": "Do you still want to continue?",
  "dialog.mfa.disable.subtitle":
    "You are about to disable Two-factor authentication which may lower the security of your account access.",
  "dialog.mfa.disable.title": "Disable Two-factor authentication",
  "dialog.mfa.enable.subtitle.email":
    "To enable this method you must provide the verification code we've sent you to your email",
  "dialog.mfa.enable.subtitle.otp":
    "Configure an authenticator app on your smartphone or other device scanning this QR.",
  "dialog.mfa.enable.title": "Enable Multi-factor authentication",
  "dialog.overQuota.cta": "Upgrade my subscription",
  "dialog.overQuota.description":
    "Unlimited vehicles<br />Collaboration<br />...and more",
  "dialog.overQuota.subtitle.collector.subscribe":
    "You need to be subscribed to perform this action",
  "dialog.overQuota.subtitle.collector.upgrade": "Ready for the Pro level?",
  "dialog.overQuota.subtitle.curator": "Ask them to upgrade",
  "dialog.overQuota.tier.current": "Your current tier",
  "dialog.overQuota.title.collector.subscribe": "Subscribe",
  "dialog.overQuota.title.collector.upgrade":
    "You have reached the limit for your current subscription tier",
  "dialog.overQuota.title.curator":
    "{{username}} has reached the limit for their current subscription tier",
  "dialog.passphrase.confirm": "Confirm passphrase",
  "dialog.passphrase.new": "New passphrase",
  "dialog.passphrase.old": "Old passphrase",
  "dialog.passphrase.required.subtitle":
    "For your security, your passphrase is used to generate a key that is kept only temporarily and may be cleared from memory during your session. Because of this, you might be asked to enter your passphrase again.",
  "dialog.passphrase.subtitle":
    "Please store this passphrase in a secure place. You will need it to access your encrypted files. If you forget it, it cannot be recovered, and you will lose access to your data. While you can change your passphrase if it becomes compromised, you will need the current passphrase to do so",
  "dialog.passphrase.title": "Passphrase",
  "dialog.reminder.delete.content":
    "You are about to delete the <strong>{{title}}</strong> reminder for <strong>{{date}}</strong>, are you sure about it?",
  "dialog.reminder.delete.title": "Delete reminder",
  "dialog.reminder.manage.title": "Manage reminder",
  "dialog.remove.confirmButton": "Yes, remove",
  "dialog.service.delete.content":
    "You are about to delete the <strong>{{title}}</strong> service, are you sure about it?",
  "dialog.service.delete.title": "Delete service",
  "dialog.service.manage.title": "Manage service",
  "dialog.serviceRequest.accept.confirm":
    "Are you sure you want to accept this request?",
  "dialog.serviceRequest.cancel.confirm":
    "Are you sure you want to cancel this request?",
  "dialog.serviceRequest.complete.confirm":
    "Are you sure you want to complete this request?",
  "dialog.serviceRequest.create.title": "Service request",
  "dialog.serviceRequest.create.title.withVehicle":
    "{{vehicle}} - Service request",
  "dialog.serviceRequest.delete.title": "Delete service request",
  "dialog.serviceRequest.manage.title": "Manage service request",
  "dialog.subscription.tierSelection.title":
    "Select the tier that suits your needs",
  "dialog.tag.create.subtitle":
    "You will be able to associate this tag with your documents",
  "dialog.tag.create.title": "Create tag",
  "dialog.tag.delete.content":
    "You are about to delete <strong>{{tagName}}</strong>. This will remove the tag from all associated files and cannot be undone. Do you want to proceed?",
  "dialog.tag.delete.title": "Delete tag",
  "dialog.tag.delete.warning": "This action cannot be undone!",
  "dialog.tag.rename.subtitle":
    "This action will rename the tag for all associated files",
  "dialog.tag.rename.title": "Rename tag",
  "dialog.transactions.dataRoom.externalLinks.subtitle":
    "You can then allow access to this group of links per negotiation",
  "dialog.transactions.dataRoom.externalLinks.title":
    "Select links relevant to negotiation",
  "dialog.transactions.dataRoom.gallery.subtitle":
    "You can then allow access to this gallery per negotiation",
  "dialog.transactions.dataRoom.gallery.title":
    "Select medias relevant to negotiation",
  "dialog.transactions.dataRoom.vault.subtitle":
    "You can then allow access to this group of files per negotiation",
  "dialog.transactions.dataRoom.vault.title":
    "Select files relevant to negotiation",
  "dialog.user.accountDelete.admin.content":
    "You are about to delete <strong>{{user}}'s</strong> ({{email}}) Driven account, are you sure about it?",
  "dialog.user.accountDelete.content":
    "We are sorry to see you go! You are about to delete your account, are you sure about it?",
  "dialog.user.accountDelete.content.2fa":
    "This action requires 2FA confirmation to proceed",
  "dialog.user.accountDelete.instructions":
    "Please type <strong>delete account</strong> below to confirm;",
  "dialog.user.accountDelete.title": "Delete account",
  "dialog.vehicle.add.managedBy": "Managed by a partner?",
  "dialog.vehicle.add.managedByHint":
    "Partner can manage the vehicle on your behalf, including vault and logbook. Billing is handled by partner.",
  "dialog.vehicle.add.selfManagedHint":
    "Self managed vehicles are private, but can be consigned to a partner in the future. It will be billed as part of your subscription.",
  "dialog.vehicle.collection.remove.confirmButton": "Remove",
  "dialog.vehicle.collection.remove.content":
    "You are about to remove <strong>{{vehicleTitle}}</strong> from <strong>{{collectionTitle}}</strong>, are you sure about it?",
  "dialog.vehicle.collection.remove.success": "Vehicle removed from collection",
  "dialog.vehicle.collection.remove.title": "Remove vehicle from collection",
  "dialog.vehicle.delete.confirm":
    "You are about to delete <strong>{{title}}</strong>, are you sure about it? Whilst the vehicle can be recovered, Data Rooms will be deleted and all memberships will be revoked.",
  "dialog.vehicle.delete.managedByPartner":
    "This vehicle is managed by a partner",
  "dialog.vehicle.delete.title": "Delete vehicle",
  "dialog.vehicle.externalLinks.edit.content":
    "Edit the external links related to your vehicle",
  "dialog.vehicle.externalLinks.edit.title": "External links",
  "dialog.vehicle.history.upload.helper":
    "Drag and drop any files or media that you would like to include in this event, they will be safely stored in this vehicle vault. Removing a file does not delete it from the vault.",
  "dialog.vehicle.historyRecord.draft": "Save to remove draft status",
  "dialog.vehicle.historyRecord.mileage.error":
    "Required when selected type is Odometer",
  "dialog.vehicle.historyRecord.price.error":
    "Required when selected type is Market value",
  "dialog.vehicle.historyRecord.title": "History record",
  "dialog.vehicle.historyRecord.title.withVehicle":
    "{{vehicle}} - History record",
  "dialog.vehicle.location.managedByPartner":
    "This vehicle location is managed by a partner",
  "dialog.vehicle.location.remove.confirmButton": "Remove",
  "dialog.vehicle.location.remove.content":
    "You are about to remove <strong>{{vehicleTitle}}</strong> from <strong>{{locationTitle}}</strong>, are you sure about it?",
  "dialog.vehicle.location.remove.success": "Vehicle removed from location",
  "dialog.vehicle.location.remove.title": "Remove vehicle from location",
  "dialog.vehicle.location.update": "Select vehicle location",
  "dialog.vehicle.organization.assign.success":
    "Vehicle assigned to organization",
  "dialog.vehicle.organization.assign.title": "Assign vehicle to organization",
  "dialog.vehicle.organization.withdraw.confirmButton": "Withdraw",
  "dialog.vehicle.organization.withdraw.content":
    "You are about to withdraw <strong>{{vehicleTitle}}</strong> from <strong>{{organization}}</strong>, are you sure about it?",
  "dialog.vehicle.organization.withdraw.success":
    "Vehicle withdrawn from organization",
  "dialog.vehicle.organization.withdraw.title":
    "Withdraw vehicle from organization",
  "dialog.vehicle.status.update": "Update vehicle status",
  "dialog.vehicle.tags.edit.title": "Edit tags",
  "dialog.vehicle.transfer.description":
    "Share this link with the new owner, when they accept the transfer, you will be shown their account details to confirm the transfer. The vehicle (vault, logbook, etc) will be cloned to their account, and you will keep the original in your Garage with all its history.",
  "dialog.vehicle.transfer.title": "Transfer vehicle",
  "dialog.vehicle.unarchive.confirmButton": "Unarchive vehicle",
  "dialog.vehicle.unarchive.content":
    "You are about to restore <strong>{{vehicleTitle}}</strong> from the archive. By doing so, it will take one slot at your garage.",
  "dialog.vehicle.unarchive.title": "Restoring vehicle from archive",
  "dialog.vehicle.vault.assignToHistoryRecord.subtitle":
    "Select a Log Book record to assign <strong>{{filename}}</strong> to",
  "dialog.vehicle.vault.assignToHistoryRecord.title":
    "Assign to Log Book record",
  "dialog.vehicle.vault.assignToVehicle.subtitle":
    "Select a Vehicle to assign <strong>{{filename}}</strong> to",
  "dialog.vehicle.vault.assignToVehicle.title": "Assign to Vehicle",
  "dialog.vehicle.vault.bin.empty": "The bin is empty.",
  "dialog.vehicle.vault.bin.subtitle":
    "Documents are kept in the bin and can be recovered for 30 days.",
  "dialog.vehicle.vault.bin.title": "Bin",
  "dialog.vehicle.vault.document.decrypt": "Decrypt document",
  "dialog.vehicle.vault.document.encrypt": "Encrypt document",
  "dialog.wishlist.delete.content":
    "You are about to delete the wishlist for <1>{{title}}</1>, are you sure about it?",
  "dialog.wishlist.delete.title": "Delete wishlist item",
  "dialog.wishlist.details.title": "Vehicle in wishlist",
  dimensions: "Dimensions",
  disable: "Disable",
  discard: "Discard",
  distance: "Distance",
  distanceUnit: "Distance Unit",
  documents: "Documents",
  download: "Download",
  draft: "Draft",
  drafts: "Drafts",
  draftsOnly: "Drafts only",
  driveTrainLabel: "Drive Train",
  eapBilling: "EAP Billing",
  eapTier: "EAP Tier",
  edit: "Edit",
  editCollection: "Edit collection",
  editCollector: "Edit collector",
  editDescription: "Edit description",
  editExternalLinks: "Edit external links",
  editExternalLinksInVehicle: "Edit vehicle's external links",
  editFile: "Edit file",
  editListing: "Edit Data Room",
  editLocation: "Edit location",
  editPhotosAndVideos: "Edit photos & videos",
  editPhotosAndVideosInVehicle: "Edit vehicle's photos & videos",
  editProfile: "Edit profile",
  editSpecifications: "Edit specifications",
  editSpecificationsInVehicle: "Edit vehicle's specifications",
  editSpecs: "Edit specs",
  editTags: "Edit tags",
  editTechnicalData: "Edit technical data",
  editVaultInVehicle: "Edit vehicle's vault",
  editVehicle: "Edit vehicle",
  editVehicleData: "Edit vehicle data",
  editWishlist: "Edit wishlist",
  email: "Email",
  emailNotSent: "Email couldn't be sent. Please try again later.",
  emailSent: "Email has been sent",
  emptyActivity: "There is no activity recorded for this vehicle yet.",
  emptyCollection:
    "This collection is empty. You can add your desired vehicles to this collection by clicking bellow.",
  emptyCollections:
    "Collections are a great way of organizing your Garage. You can create your first collection now!",
  emptyGarage:
    "Here you will be able to find all the vehicles you upload to your Garage. You can upload your first vehicle now!",
  emptyGarageLogbook:
    "Here you will be able to find all the history records from all vehicles in your garage.",
  emptyGarageOnManageVehicles:
    "You don't have any vehicle in your Garage yet. You can upload your first vehicle now!",
  emptyGarageUnsubscribed: "Upload your first vehicle now!",
  emptyInvoices:
    "There are currently no invoices to show. Once the first invoice is billed it will be shown here.",
  emptyLocation:
    "This location is empty. You can add your desired vehicles to this location by clicking bellow.",
  emptyLocations:
    "Locations are a great way of organizing your Garage. You can create your first location now!",
  emptyPaymentMethods:
    "You don't have any payment method configured yet. You can add your first payment method now!",
  enable: "Enable",
  encrypt: "Encrypt",
  engine: "Engine",
  "error.boundary.description":
    "We are sorry, but something went wrong. Please try again later or contact support if the problem persists.",
  "error.boundary.title": "Oops! Something went wrong",
  "error.dataRoom.dataRoomGroupNotFound": "Data room group not found",
  "error.dataRoom.dataRoomNotFound": "Data room not found",
  "error.dataRoom.logbookInconsistent": "Data room logbook is inconsistent",
  "error.dataRoom.membershipNotFound": "Data room membership not found",
  "error.dataRoom.membershipSameOwner":
    "You cannot confirm an invitation to your own data room",
  "error.dataRoom.vaultInconsistent": "Data room vault is inconsistent",
  "error.form.maxYear": "Year has to be under {{year}}",
  "error.form.minYear": "Year has to be over {{year}}",
  "error.form.yearToLessThanYearFrom": "Must be greater or equal",
  "error.historyRecord.notFound": "History record not found",
  "error.max.files": "Maximum number of files exceeded",
  "error.media.fileOversize": "File over the max size of {{maxSize}}",
  "error.media.invalidFileStorage": "Invalid file storage",
  "error.media.invalidProvider": "Invalid media provider",
  "error.media.mediaCannotBeDeleted": "Media cannot be deleted error",
  "error.media.mediaNotFound": "Media not found",
  "error.media.mediaResizeNotAllowed": "Media cannot be resized",
  "error.media.mediaUploadNotAllowed": "Media cannot be uploaded",
  "error.media.noTextDetected": "No text detected",
  "error.media.systemTagCannotBeDeleted": "System tag cannot be deleted",
  "error.media.systemTagCannotBeRenamed": "System tag cannot be renamed",
  "error.media.tagNameAlreadyExists": "Tag name already exists error",
  "error.media.tagNotFound": "Tag not found",
  "error.media.vaultNotFound": "Vault not found",
  "error.shared.invalidDate": "Invalid date",
  "error.shared.invalidEmail": "Invalid email",
  "error.shared.invalidLimit": "Invalid limit",
  "error.shared.invalidPassword": "Invalid password",
  "error.shared.invalidUsername": "Invalid username",
  "error.shared.invalidUuid": "Invalid uuid",
  "error.shared.invalidVerificationStatus": "Invalid verification status",
  "error.shared.invalidVin": "Invalid vin",
  "error.shared.overQuota": "Current quotas reached",
  "error.user.cannotDecrypt": "Cannot decrypt data",
  "error.user.cannotEncrypt": "Cannot encrypt data",
  "error.user.captchaInvalid": "Cannot validate captcha",
  "error.user.collectorCantAddHimselfToCrewError":
    "Collector can't add themselves as crew member",
  "error.user.collectorSubscriptionAlreadyActive":
    "You are already subscribed. Check it on your subscription settings.",
  "error.user.collectorSubscriptionNotPaid":
    "Payment failed. Use a different payment method to continue.",
  "error.user.confirmCrewMembershipForbidden":
    "Error confirming crew membership",
  "error.user.crewMembershipNotFound": "Membership was not found",
  "error.user.emailAlreadyRegistered": "Email already registered",
  "error.user.identificationChangeNotAllowed":
    "Identification data change is not allowed for current status",
  "error.user.inactiveAccount": "Inactive account",
  "error.user.inappropriateBio": "Bio contains inappropriate words",
  "error.user.inappropriateUsername": "Username contains inappropriate words",
  "error.user.invalidCredentials": "Invalid credentials",
  "error.user.invalidEncryptedPassword": "Invalid encrypted password",
  "error.user.invalidProfilePictureOwner": "Invalid profile picture owner",
  "error.user.invalidRejectionReason": "Invalid rejection reason",
  "error.user.invalidToken": "Invalid token",
  "error.user.invalidTokenScope": "Invalid token scope",
  "error.user.loginFailed": "Login failed",
  "error.user.maxIdentityFilesNumber": "Max identity files reached",
  "error.user.multiFactorAuthenticationVerification":
    "Invalid 2FA verification code",
  "error.user.profilePictureNotFound": "Profile picture not found",
  "error.user.promotionCodeExpired": "Promotion code is expired",
  "error.user.promotionCodeInactive": "Promotion code is inactive",
  "error.user.tokenNotFound": "Token not found",
  "error.user.userAlreadyConfirmed": "User already confirmed",
  "error.user.usernameAlreadyTaken": "Username already taken",
  "error.user.usernameOrPasswordInvalid": "Username or Password invalid",
  "error.user.userNotFound": "User not found",
  "error.vehicle.cannotShowInterestForOwnListing":
    "Cannot show interest for own listing",
  "error.vehicle.collectionNotFound": "Collection not found",
  "error.vehicle.duplicatedListing": "Vehicle has an active listing",
  "error.vehicle.invalidCurrency": "Invalid currency {{currency}}",
  "error.vehicle.invalidDistance": "Invalid distance",
  "error.vehicle.invalidDistanceUnit": "Invalid distance unit {{unit}}",
  "error.vehicle.invalidMeasure": "Invalid measure for value {{value}}",
  "error.vehicle.invalidMonth": "Invalid production month",
  "error.vehicle.invalidPrice": "Invalid price",
  "error.vehicle.invalidPriceRange": "Invalid price range",
  "error.vehicle.invalidSpecsString": "Invalid json string for specs",
  "error.vehicle.invalidVehicleForCollection": "Invalid vehicle for collection",
  "error.vehicle.invalidYear": "Invalid production year",
  "error.vehicle.locationNotFound": "Location not found",
  "error.vehicle.mileageNotFound": "Mileage not found",
  "error.vehicle.valuationNotFound": "Market valuation not found",
  "error.vehicle.vehicleAlreadyClaimed": "Vehicle already claimed",
  "error.vehicle.vehicleClaim": "Failed to claim the vehicle",
  "error.vehicle.vehicleNotFound": "Vehicle not found",
  "error.vehicle.vehicleReadOnly": "Vehicle is read-only",
  errorSavingCollection: "Error saving collection, please try again later",
  errorSavingCollector: "Error saving collector, please try again later",
  errorSavingConcierge: "Error saving concierge, please try again later",
  errorSavingLocation: "Error saving location, please try again later",
  errorSavingVehicle: "Error saving vehicle, please try again later",
  "exclusivePreview.message":
    "Discover your new vehicle with Driven Transactions",
  "exclusivePreview.title": "Exclusive preview",
  "exclusivePreviewBlocker.ksp.crew": "Bring in your <strong>crew</strong>",
  "exclusivePreviewBlocker.ksp.garageManagement":
    "Professional <strong>garage management</strong>",
  "exclusivePreviewBlocker.ksp.offMarket":
    "Off-market <strong>private sales</strong>",
  "exclusivePreviewBlocker.seeMore.text":
    "At Driven you can <strong>manage your garage professionally</strong> and participate in the first <strong>online off-market car transactions</strong>",
  "exclusivePreviewBlocker.seeMore.title": "Sign up to see more",
  expiryDate: "Expiry date",
  explore: "Explore",
  "explore.empty.content":
    "No results found. Try adjusting your <strong>filters</strong>.",
  "explore.empty.title": "No results found",
  "explore.form.error":
    "Something went wrong while loading results,, please try again or refresh the page",
  exploreVehicles: "Explore vehicles",
  externalId: "External ID",
  externalLinks: "External Links",
  favorite: "Default method",
  file: "File",
  filename: "Filename",
  filenameRequired: "Filename is required",
  "files.count_one": "File",
  "files.count_other": "Files ({{count}})",
  filesAttached: "Files attached",
  "filesAttached.count_one": "File attached",
  "filesAttached.count_other": "{{count}} files attached",
  fileUploadHelperText:
    "Drag 'n' drop some files here, or click to select files",
  fileUploadHelperTextSingle:
    "Drag 'n' drop a file here, or click to select a file",
  fileVault: "Vault",
  filter: "Filter",
  "filter.listing.visibility": "Show",
  "filter.listing.visibility.active": "Active only",
  "filter.listing.visibility.delisted": "Delisted only",
  "filter.logbook.record.type": "Type",
  "filter.logbook.record.type.bought": "Bought",
  "filter.logbook.record.type.concoursDElegance": "Concours d'Elegance",
  "filter.logbook.record.type.event": "Event",
  "filter.logbook.record.type.mileage": "Mileage",
  "filter.logbook.record.type.odometer": "Odometer",
  "filter.logbook.record.type.previousOwner": "Previous Owner",
  "filter.logbook.record.type.racetrackEvent": "Racetrack Event",
  "filter.logbook.record.type.restoration": "Restoration",
  "filter.logbook.record.type.service": "Service",
  "filter.logbook.record.type.sold": "Sold",
  "filter.logbook.record.type.trophy": "Trophy",
  "filter.logbook.record.type.tuning": "Tuning",
  "filter.logbook.record.type.unknown": "Unknown",
  "filter.logbook.record.type.valuation": "Market value",
  "filter.negotiations.role": "Role",
  "filter.negotiations.role.buyer": "Buyer",
  "filter.negotiations.role.seller": "Seller",
  "filter.negotiations.status": "Status",
  "filter.negotiations.status.closed": "Closed",
  "filter.negotiations.status.open": "Open",
  "filter.serviceRequests.status": "Status",
  "filter.serviceRequests.status.canceled": "Canceled",
  "filter.serviceRequests.status.closed": "Closed",
  "filter.serviceRequests.status.completed": "Completed",
  "filter.serviceRequests.status.ongoing": "Ongoing",
  "filter.serviceRequests.status.open": "Open",
  "filter.serviceRequests.status.requested": "Requested",
  "filter.vehicle.visibility": "Visibility",
  "filter.vehicle.visibility.all": "Visibility: All",
  "filter.vehicle.visibility.archived": "Visibility: Archived only",
  "filter.vehicle.visibility.transferred": "Visibility: Transferred only",
  filtered: "Filtered",
  finishCuration: "Finish curation",
  forgotPassword: "Forgot password?",
  freeport: "Freeport",
  fromYear: "From year",
  fullGallery: "Full gallery",
  gallery: "Gallery",
  garage: "Garage",
  garageError:
    "Something went wrong while loading your collection, please refresh",
  generalInfo: "General info",
  goBack: "Go back",
  goToCollection: "Go to Collection",
  goToDetail: "Go to detail",
  goToHome: "Go to home",
  goToLocation: "Go to Location",
  goToLogbook: "Go to Logbook",
  goToLogin: "Go to Login",
  goToSettings: "Go to settings",
  goToVault: "Go to Vault",
  goToVehicles: "Go to Vehicles",
  "gpt.reasoning": "AI reasoning",
  "gpt.valuation": "AI valuation",
  "gpt.warning":
    "AI can make mistakes. Consider checking important information.",
  "grid.bin": "Bin",
  "grid.bulkEdit": "Bulk",
  "grid.export.csv": "CSV",
  "grid.exportCurrentView": "Export current view",
  "grid.hideAll": "Hide all",
  "grid.save": "Save",
  "grid.saveAs": "Save as",
  "grid.selectColumns": "Columns",
  "grid.selectView": "Select view",
  "grid.showAll": "Show all",
  help: "Help",
  helpCenter: "Help center",
  highlight: "Highlight",
  highlights: "Highlights",
  highlightsOnly: "Highlights only",
  history: "History",
  historyRecord: "History record",
  "historyRecord.add": "Add history record",
  "historyRecord.add.error.content":
    "There was a problem adding your history record.",
  "historyRecord.add.marketValue": "Add market value record",
  "historyRecord.add.odometerReading": "Add odometer reading record",
  "historyRecord.attachments.help":
    "Attachments will be also accessible from the vehicle's vault.",
  "historyRecord.deleteRecords": "Delete records",
  "historyRecord.edit": "Edit history record",
  "historyRecord.empty":
    "There are no history records yet. Add the first one and start building the history of your vehicles!",
  "historyRecord.goTo": "Go to history record",
  "historyRecord.recordedOn": "Recorded on {{date}}",
  "historyRecord.reviewDraft": "Review draft",
  "historyRecord.saveDrafts": "Save drafts",
  "historyRecord.step.details.description":
    "You can create your own type of history record",
  "historyRecord.step.details.title": "History record",
  "historyRecord.type.bought": "Bought",
  "historyRecord.type.concoursDElegance": "Concours d'Elegance",
  "historyRecord.type.custom": "Custom",
  "historyRecord.type.event": "Event",
  "historyRecord.type.odometer": "Odometer",
  "historyRecord.type.previousOwner": "Previous owner",
  "historyRecord.type.racetrackEvent": "Racetrack event",
  "historyRecord.type.restoration": "Restoration",
  "historyRecord.type.service": "Service",
  "historyRecord.type.sold": "Sold",
  "historyRecord.type.trophy": "Trophy",
  "historyRecord.type.tuning": "Tuning",
  "historyRecord.type.unknown": "Unknown",
  "historyRecord.type.valuation": "Market value",
  id: "ID",
  idle: "Idle",
  import: "Import",
  inactive: "inactive",
  insuredValue: "Insured value",
  invoiceNumber: " Invoice Number",
  invoicesError:
    "The invoice list is currently not available. Please, refresh the page or try again in a bit. Your data is safe.",
  issuedDate: "Issued Date",
  joinTheCommunity: "Join the community",
  km: "Kilometers",
  language: "Language",
  "language.de": "German",
  "language.en": "English",
  languageRequired: "Language is required",
  latestAccesses: "Latest accesses",
  "layouts.block.empty.edit":
    "Select the blocks above which you want to see in your dashboard",
  "layouts.block.empty.view":
    "Go to edit mode to select the blocks you want to see in your dashboard",
  "layouts.dashboard.block.ai-valuation": "AI valuation",
  "layouts.dashboard.block.financial-summary": "Financial summary",
  "layouts.dashboard.block.financial-summary-total-current-price":
    "Total value of assets",
  "layouts.dashboard.block.financial-summary-total-purchase-price":
    "Total purchases",
  "layouts.dashboard.block.financial-summary-total-realized-gain":
    "Realized profit",
  "layouts.dashboard.block.financial-summary-total-sales-price": "Total sales",
  "layouts.dashboard.block.financial-summary-total-unrealized-gain":
    "Unrealized profit",
  "layouts.dashboard.block.latest-activity": "Latest activity",
  "layouts.dashboard.block.latest-memory": "Memories",
  "layouts.dashboard.block.performance-chart": "Performance Chart",
  "layouts.dashboard.block.your-garage": "Your Garage",
  "layouts.vehicleDetail.block.activity": "Activity",
  "layouts.vehicleDetail.block.ai-valuation": "AI valuation",
  "layouts.vehicleDetail.block.collections": "Collections",
  "layouts.vehicleDetail.block.description": "Description",
  "layouts.vehicleDetail.block.external-links": "External links",
  "layouts.vehicleDetail.block.gallery": "Gallery",
  "layouts.vehicleDetail.block.insurance-value": "Insurance value",
  "layouts.vehicleDetail.block.location": "Location",
  "layouts.vehicleDetail.block.market-valuation": "Market valuation",
  "layouts.vehicleDetail.block.mileage": "Mileage",
  "layouts.vehicleDetail.block.performance": "Performance",
  "layouts.vehicleDetail.block.purchase-price": "Purchase price",
  "layouts.vehicleDetail.block.reminders": "Reminders",
  "layouts.vehicleDetail.block.sale-price": "Sale price",
  "layouts.vehicleDetail.block.specifications": "Specifications",
  "layouts.vehicleDetail.block.taxable-value": "Taxable value",
  "layouts.vehicleDetail.block.technical-data": "Technical data",
  "layouts.vehicleDetail.block.valuation": "Valuation",
  "layouts.vehicleDetail.block.vehicle-data": "Vehicle data",
  licensePlate: "License plate",
  linkCopied: "Link copied",
  listed: "Listed",
  "listing.status.active": "Active",
  "listing.status.delisted": "Delisted",
  listVehicle: "List vehicle on transactions",
  loading: "Loading…",
  loadRest: "Load rest",
  location: "Location",
  "location.count_one": "{{count}} location",
  "location.count_other": "{{count}} locations",
  "location.managedByPartner":
    "This location is managed by <strong>{{title}}</strong>",
  "location.step.pickVehicles.selected": "You have selected",
  locationNotFound: "Location not found",
  locations: "Locations",
  locationType: "Location type",
  logBook: "Log Book",
  "logBook.makeModel": "{{make}} {{model}}'s logbook",
  logbookInvitation:
    "The Log Book will help you to keep a detailed history of your vehicle. You can start straight away by adding any of the following entries. <1>All the documents you upload will be safely stored in your Vault.</1>",
  login: "Login",
  loginClaim: "Not yet a member?",
  loginError:
    "Invalid credentials. Reset your password if you are already registered or avoid swear words",
  loginHere: "Login here",
  logout: "Logout",
  "maintenance.description":
    "Driven is down for maintenance work, you will be able to access the platform again very shortly. <strong>Follow us on our social media for updates.</strong>",
  "maintenance.subtitle": "We will be back on the road shortly!",
  "maintenance.title": "Uh-oh.. Check engine!",
  make: "Make",
  makes: "Makes",
  manageCollections: "Manage collections",
  manageLocations: "Manage locations",
  manageVehicle: "Manage vehicle",
  maxPrice: "Max price",
  measurementDate: "Measurement date",
  member: "Member",
  message: "Message",
  "messageBoard.role.admin": "Admin",
  "messageBoard.role.collector": "Collector",
  "messageBoard.role.concierge": "Concierge",
  "messageBoard.role.curator": "Curator",
  "messageBoard.role.unknown": "Unknown",
  "messageBoard.role.you": "You",
  "messageBoard.send": "Send",
  "messageBoard.system.dataRoom.layout_membership_confirmed_v1":
    "{{fullName}} accepted an invitation to the Data Room",
  "messageBoard.system.dataRoom.layout_membership_confirmed_v1.preview":
    "Invitation to the Data Room accepted",
  "messaging.admin.user.deleted": "User deleted",
  "messaging.collection.added": "Collection added",
  "messaging.collection.deleted": "Collection deleted",
  "messaging.collection.details.updated": "Collection details updated",
  "messaging.collection.vehicles.updated": "Vehicles in collection updated",
  "messaging.collector.added": "Collector added",
  "messaging.collector.details.updated": "Collector details updated",
  "messaging.concierge.added": "Concierge created",
  "messaging.concierge.isActiveUpdated.activated": "Activated",
  "messaging.concierge.isActiveUpdated.deactivated": "Deactivated",
  "messaging.concierge.promoted": "{{fullName}} promoted",
  "messaging.concierge.promoted.error": "Error promoting {{fullName}}",
  "messaging.crew.invitation.sent": "Invitation sent",
  "messaging.curation.add": "{{member}} was added to your crew",
  "messaging.curation.end": "Curation session ended",
  "messaging.curation.remove":
    "{{member}} is not part of {{manager}}'s crew anymore",
  "messaging.curation.start":
    "Started curation session for {{username}}'s garage",
  "messaging.dataRoom.added": "Data Room added",
  "messaging.dataRoom.deleted": "Data Room deleted",
  "messaging.dataRoom.group.updated": "Data Room group updated",
  "messaging.dataRoom.membership.invitationCreated":
    "Membership invitation created",
  "messaging.dataRoom.membership.revoked": "Membership revoked",
  "messaging.dataRoom.membership.revoked.failed": "Failed to revoke membership",
  "messaging.dataRoom.membership.withdrawn": "Membership withdrawn",
  "messaging.dataRoom.membership.withdrawn.failed":
    "Failed to withdraw membership",
  "messaging.dataRoom.permissions.updated": "Data Room permissions updated",
  "messaging.dataRoom.updated": "Data Room updated",
  "messaging.dealer.added": "Dealer added",
  "messaging.error.tryAgain": "Something went wrong. Please try again.",
  "messaging.garage.vehicles.added": "Vehicles added to garage",
  "messaging.historyRecord.added": "History record added",
  "messaging.historyRecord.details.updated": "History record details saved",
  "messaging.listing.created": "Data Room created",
  "messaging.listing.delisted": "Data Room delisted",
  "messaging.listing.interest.accepted": "Interest accepted",
  "messaging.listing.interest.rejected": "Interest rejected",
  "messaging.listing.interest.withdrawn": "Interest withdrawn",
  "messaging.listing.updated": "Data Room updated",
  "messaging.location.added": "Location added",
  "messaging.location.deleted": "Location deleted",
  "messaging.location.details.updated": "Location details updated",
  "messaging.location.vehicles.updated": "Vehicles in location updated",
  "messaging.mfa.confirmed": "2FA confirmed",
  "messaging.mfa.disabled": "2FA successfully disabled",
  "messaging.mfa.enabled": "2FA successfully enabled",
  "messaging.reminder.created": "Reminder created",
  "messaging.reminder.deleted": "Reminder deleted",
  "messaging.reminder.updated": "Reminder updated",
  "messaging.service.created": "Service created",
  "messaging.service.deleted": "Service deleted",
  "messaging.service.updated": "Service updated",
  "messaging.serviceRequest.accepted": "Service request accepted",
  "messaging.serviceRequest.canceled": "Service request canceled",
  "messaging.serviceRequest.created": "Service requested",
  "messaging.serviceRequest.deleted": "Service request deleted",
  "messaging.serviceRequest.updated": "Service request updated",
  "messaging.settings.creditCard.deleted": "Credit card successfully deleted",
  "messaging.settings.creditCard.setDefault":
    "Credit card successfully set as default",
  "messaging.subscription.invoice.downloading": "Preparing invoice download",
  "messaging.tag.created": "Tag created",
  "messaging.tag.deleted": "Tag deleted",
  "messaging.tag.renamed": "Tag renamed",
  "messaging.user.added": "User created",
  "messaging.user.avatar.updated": "Profile picture updated",
  "messaging.user.crewMembership.inviteCreated": "Invite has been created",
  "messaging.user.crewMembershipCreated.verified": "Crew Membership Accepted",
  "messaging.user.data.updated": "User data updated",
  "messaging.user.email.changing": "Mail sent to new email",
  "messaging.user.email.verified": "Email verified",
  "messaging.user.listView.saved": "List view saved",
  "messaging.user.passphrase.updated": "Passphrase updated",
  "messaging.user.passphrase.used": "Data Encryption Key available",
  "messaging.user.password.updated": "Password updated",
  "messaging.user.paywall.changed": "Paywall settings updated",
  "messaging.user.paywall.error": "Error while updating paywall settings",
  "messaging.user.verification.submitted": "Verification request submitted",
  "messaging.user.welcome": "Welcome",
  "messaging.vehicle.added": "Vehicle added",
  "messaging.vehicle.collections.updated": "Vehicle collections updated",
  "messaging.vehicle.consignment.updated": "Vehicle consignment updated",
  "messaging.vehicle.deleted": "Vehicle deleted",
  "messaging.vehicle.details.updated": "Vehicle details updated",
  "messaging.vehicle.externalLinks.updated": "Vehicle external links updated",
  "messaging.vehicle.history.deleted": "Vehicle history record removed",
  "messaging.vehicle.history.deleted.bulk": "Selected history records removed",
  "messaging.vehicle.history.deleted.bulk.error":
    "Failed to remove all selected history records",
  "messaging.vehicle.history.draft.saved.bulk":
    "Selected history record drafts saved",
  "messaging.vehicle.history.draft.saved.bulk.error":
    "Failed to save all selected history record drafts",
  "messaging.vehicle.history.recovered": "Vehicle history record recovered",
  "messaging.vehicle.location.updated": "Vehicle location updated",
  "messaging.vehicle.recovered": "Vehicle recovered",
  "messaging.vehicle.specs.updated": "Vehicle specifications updated",
  "messaging.vehicle.status.updated": "Vehicle status updated",
  "messaging.vehicle.technicalData.updated": "Vehicle technical data updated",
  "messaging.vehicle.transfer.claimed": "Vehicle transfer claimed",
  "messaging.vehicle.vault.document.decrypted": "Document decrypted",
  "messaging.vehicle.vault.document.deleted": "Document removed",
  "messaging.vehicle.vault.document.deleted.bulk": "Documents removed",
  "messaging.vehicle.vault.document.deleted.bulk.error":
    "Failed to remove all selected history records",
  "messaging.vehicle.vault.document.encrypted": "Document encrypted",
  "messaging.vehicle.vault.document.recovered": "Document recovered",
  "messaging.vehicle.vault.document.updated": "Document updated",
  "messaging.vehicle.vault.uploaded": "Document uploaded",
  "messaging.vehicle.verification.submitted": "Verification request submitted",
  "messaging.welcomeEmail.sent": "Welcome email sent",
  "messaging.wishlist.created": "Added to wishlist",
  "messaging.wishlist.deleted": "Removed from wishlist",
  "messaging.wishlist.deleteOriginal": "Delete original wishlist item",
  "messaging.wishlist.specs.updated": "Wishlist specifications updated",
  "messaging.wishlist.updated": "Wishlist updated",
  mfaCantAccessAuthApp: "Can't access your authenticator app?",
  mfaCantAccessEmail: "Can't access your mail?",
  mfaCantAccessWebAuthn: "Don't you have your device with you?",
  mfaCodeError: "The code is incorrect, please try again",
  mfaCodeRequired: "A 6-digit code is required",
  mfaDeviceAuthenticationError:
    "There was an error verifying your device, please try again later",
  mfaMethodError:
    "There was an error managing 2FA method, please try again later",
  mfaMethodRequired: "Method is required",
  mfaTokenRequired: "MFA token is required",
  mfaUseAuthApp: "Use authenticator app",
  mfaUseEmail: "Send code to email",
  mfaUseWebAuthn: "Use physical device",
  mi: "Miles",
  minPrice: "Min price",
  model: "Model",
  models: "Models",
  month: "Month",
  moreActions: "More actions",
  motorcycle: "Motorcycle",
  myListings: "My Data Rooms",
  name: "Name",
  nameRequired: "Name is required",
  needHelp: "Need help?",
  "negotiation.backToNegotiation": "Back to Discussions",
  "negotiation.closedDiscussions": "Closed Discussions",
  "negotiation.messages.disabled.buyerCannotChat":
    "Buyer is not allowed to send you any more messages unless the discussion is ongoing",
  "negotiation.messages.disabled.buyerInterestStatus":
    "You cannot send any more messages, before seller accepts your interest.",
  "negotiation.messages.disabled.canceledStatus":
    "Discussion has been canceled",
  "negotiation.messages.disabled.completedStatus":
    "Discussion has been completed",
  "negotiation.messages.send": "Send",
  "negotiation.openDiscussions": "Open Discussions",
  "negotiation.role": "Discussion role",
  "negotiation.role.buyer": "Buyer",
  "negotiation.role.buyer.verb": "Buying",
  "negotiation.role.seller": "Seller",
  "negotiation.role.seller.verb": "Selling",
  "negotiation.role.you": "You",
  "negotiation.status": "Discussion status",
  "negotiation.status.canceled": "Canceled",
  "negotiation.status.completed": "Completed",
  "negotiation.status.interest": "Interest",
  "negotiation.status.ongoing": "On going",
  negotiations: "Discussions",
  newExternalLink: "Add external link",
  newMake: "New make",
  newModel: "New model",
  newPaymentMethod: "Add Method",
  "newsletterSignupForm.error":
    "We couldn't sign you up to the newsletter. Please try again later.",
  "newsletterSignupForm.inputPlaceholder": "Your email address",
  "newsletterSignupForm.submitButton.done": "You are in!",
  "newsletterSignupForm.text":
    "At Driven we are always implementing new stuff, let us keep you posted about our latest projects and events",
  "newsletterSignupForm.title": "Get the latest Driven updates",
  "newsletterSignupForm.title.done":
    "<0>Awesome! </0><1>We will keep you updated!</1>",
  newType: "New type",
  newVersionAvailable: "New version available!",
  no: "No",
  noCollectors: "No collectors",
  noDecimalPlaceAllowed: "No decimal place allowed",
  note: "Note",
  "notFound.description":
    "We can’t seem to find the page you were looking for as it is not available at the moment",
  "notFound.title": "404 - Wheels gone",
  "notification.button.tooltip_one": "You have {{count}} unread notification",
  "notification.button.tooltip_other":
    "You have {{count}} unread notifications",
  "notification.button.tooltip_zero": "You have no unread notifications",
  "notification.collector.identityRejected.title":
    "Identity verification failed",
  "notification.collector.identityUpdated.title": "New identity verification",
  "notification.collector.identityVerified.body":
    "With your identity successfully verified, we are now able to verify the ownership of your vehicles so they can be listed in the transactions",
  "notification.collector.identityVerified.title": "Identity verified",
  "notification.collector.removeFromOrganization.collector.body":
    "You have been removed from {{organization}}",
  "notification.collector.removeFromOrganization.concierge.body":
    "<strong>{{username}}</strong> ({{email}}) has been removed from your organization",
  "notification.collector.removeFromOrganization.concierge.title":
    "Collector removed",
  "notification.collector.signedUp.body": "{{email}} has signed up",
  "notification.collector.signedUp.title": "New collector",
  "notification.concierge.collectorsUpdated": "Assignees updated",
  "notification.concierge.created.body":
    "{{email}} has been added to your organization",
  "notification.concierge.created.title": "New concierge",
  "notification.crew.curator.membership.created.body":
    "{{member}} accepted an invitation and is now a curator in your crew",
  "notification.crew.curator.membership.created.title":
    "Crew invitation accepted",
  "notification.dataRoom.membership.accepted.title":
    "Data Room group membership accepted",
  "notification.dataRoom.membership.revoked.title":
    "Data Room group membership revoked",
  "notification.dataRoom.membership.withdrawn.body":
    "{{member}} withdrew their membership",
  "notification.dataRoom.membership.withdrawn.title":
    "Data Room group membership withdrawn",
  "notification.dataRoom.message.title": "New message",
  "notification.historyRecord.draft.content":
    "{{typeName}} record draft for {{vehicleTitle}} has been created based on recently uploaded documents. Review and save it.",
  "notification.historyRecord.draft.title": "Log Book record draft created",
  "notification.markAllAsRead": "Mark all as read",
  "notification.membership.deleted.body":
    "Your membership as a {{role}} from {{username}}'s crew was deleted",
  "notification.membership.deleted.title": "Membership deleted",
  "notification.membership.withdrawn.body":
    "{{username}} has withdrawn his membership as a {{role}} from your crew",
  "notification.membership.withdrawn.title": "Membership withdrawn",
  "notification.negotiation.accessLevels.updated.body":
    "The seller shared more information about the vehicle",
  "notification.negotiation.accessLevels.updated.title":
    "Negotiation data room updated",
  "notification.negotiation.canceled.body": "The negotiation has been canceled",
  "notification.negotiation.canceled.title": "Negotiation canceled",
  "notification.negotiation.interestAccepted.body":
    "They buyer accept your approach, you can now start the negotiation",
  "notification.negotiation.interestAccepted.title": "Interest accepted",
  "notification.negotiation.interestShown.title": "Interest for your vehicle",
  "notification.negotiation.message.buyer": "buyer",
  "notification.negotiation.message.seller": "seller",
  "notification.negotiation.message.title": "New message from {{role}}",
  "notification.serviceRequest.assigned.title":
    "You have been assigned a service request",
  "notification.serviceRequest.canceled.title": "Service request canceled",
  "notification.serviceRequest.completed.title": "Service request completed",
  "notification.serviceRequest.message.title": "New message",
  "notification.serviceRequest.ongoing.title": "Service request ongoing",
  "notification.subscription.renewal.body":
    "Your subscription will be renewed on {{renewalDate}} check your subscription settings before it happens",
  "notification.subscription.renewal.title": "Subscription renewal",
  "notification.subscription.trialEnd.body":
    "Your free trial expires on {{trialEnd}} check your subscription settings before it happens",
  "notification.subscription.trialEnd.title": "Free trial end",
  "notification.subscription.trialStart.body":
    "You can test all Driven features until {{trialEnd}}. After that, you will need a subscription to manage your garage",
  "notification.subscription.trialStart.body.partner":
    "You can test all Driven features until {{trialEnd}}. After that, you will need a subscription to manage vehicles independently of the partner organization",
  "notification.subscription.trialStart.title": "Driven trial",
  "notification.vehicle.handedOver.body":
    "Transfer of the vehicle has been confirmed",
  "notification.vehicle.handedOver.title": "Vehicle handed over",
  "notification.vehicle.organizationUpdated.added.title":
    "Vehicle added to {{organization}}",
  "notification.vehicle.organizationUpdated.title":
    "Vehicle organization updated",
  "notification.vehicle.organizationUpdated.withdrawn.title":
    "Vehicle withdrawn from {{organization}}",
  "notification.vehicle.ownershipRejected.title": "Ownership rejected",
  "notification.vehicle.ownershipUpdated.title": "New ownership verification",
  "notification.vehicle.ownershipVerified.body":
    "You can make the vehicle public or list it anonymously in the transactions",
  "notification.vehicle.ownershipVerified.title": "Ownership verified",
  "notification.vehicle.tagsUpdated": "Vehicle tags updated",
  "notification.vehicle.transferTargetUpdated.title":
    "Vehicle claimed for transfer",
  notifications: "Notifications",
  notProvided: "Not provided",
  notSet: "Not set",
  noVehicles: "No vehicles",
  number: "Number",
  numberOfCrewMembers: "# crew members",
  numberOfReadonlyVehicles: "# readonly vehicles",
  numberOfVehicles: "# vehicles",
  odometer: "Mileage",
  odometerLog: "Odometer Log",
  odometerReading: "Odometer reading",
  "onboarding.details.next": "Go to Garage",
  "onboarding.details.subtitle":
    "Your account is set up and your Garage ready to be filled with your first vehicles! What about starting your experience by customizing your profile?",
  "onboarding.details.title": "Welcome!",
  "onboarding.skipTutorial": "Skip tutorial",
  onlyOneDecimalPlaceAllowed: "Only one decimal place allowed",
  organization: "Organization",
  "organization.acme": "ACME",
  "organization.ascari": "Ascari",
  "organization.bi": "B.I. COLLECTR",
  "organization.curated": "CURATED",
  "organization.driven": "Driven",
  "organization.ilr": "ILR",
  "organization.kessel": "Kessel",
  "organization.sandbox": "Sandbox",
  "organization.vehicles.emptyState.concierge":
    "There are no vehicles assigned to you yet.",
  "organization.vehicles.emptyState.superConcierge":
    "There are no vehicles in your organization yet.",
  organizations: "Organizations",
  overview: "Overview",
  owner: "Owner",
  paid: "Paid",
  password: "Password",
  passwordNotEqual: "Passwords must match",
  passwordRequirements:
    "Password has to be between 8 and 64 characters long and it must contain digits, upper and lower case letters, and special characters",
  paywall: "Paywall",
  paywallDisableConfirm:
    "Are you sure you want to disable paywall for the selected user?",
  paywallDisabled: "Paywall disabled",
  paywallEnableConfirm:
    "Are you sure you want to enable paywall for the selected user?",
  pending: "Pending",
  performance: "Performance",
  performanceNotAvailable:
    "To display the graph, please ensure the following: 1) The initial purchase price is entered. 2) At least one history record containing a valuation, or the sale price, is available.",
  photo: "Photo",
  photos: "Photos",
  photosAndVideos: "Photos & videos",
  pickVehicles: "Pick vehicles",
  power: "Power",
  poweredBy: "Powered by",
  "prefillSpecs.description":
    "You can find the drivetrain of your vehicle in the user manual",
  "prefillSpecs.generate": "Populate using AI",
  "prefillSpecs.help":
    "After selecting the drivetrain we will automatically fill in vehicle specifications for your specific model",
  "prefillSpecs.help.disabled":
    "We could not determine the drivetrain of the vehicle model you indicated",
  "prefillSpecs.help.success":
    "Great! We automatically filled in for you some of the specifications of your selected vehicle bellow",
  "prefillSpecs.label": "Drivetrain",
  "prefillSpecs.placeholder": "Please select the drivetrain of your vehicle",
  price: "Price",
  privacyPolicy: "Privacy Policy",
  racetrack: "Racetrack",
  redacted: "[redacted]",
  referrer: "Referrer",
  register: "Register",
  registerHere: "Register here",
  rejected: "Rejected",
  relations: "Relations",
  releaseNotes: "Release notes",
  reload: "Reload",
  reloadInvoices: "Reload invoices",
  "reminders.emptyState.description":
    "Here you will be able to set reminders for your Garage. When a reminder date is due you will receive a notification and a mail",
  remove: "Remove",
  removeExternalLink: "Remove external link",
  removeFromCollection: "Remove from collection",
  removeFromLocation: "Remove from location",
  removeFromOrganization: "Remove from organization",
  rename: "Rename",
  requestAssignedTo: "Assigned to",
  resendEmail: "Resend email",
  reset: "Reset",
  resetPassword: "Reset password",
  results: "Results",
  revoke: "Revoke",
  role: "Role",
  "role.admin": "Admin",
  "role.collector": "Collector",
  "role.concierge": "Concierge",
  "role.curator": "Curator",
  "role.dealer": "Dealer",
  "role.dealership": "Dealership",
  "role.organization_manager": "Organization manager",
  "sandbox.create.description":
    "Create a sandbox user to test the platform in a safe environment",
  "sandbox.create.finished":
    "Your sandbox has been provisioned, reload to see all vehicles",
  "sandbox.create.success":
    "Your sandbox user has been created, vehicles are being provisioned and will appear in your garage shortly",
  "sandbox.create.title": "Create sandbox",
  save: "Save",
  saveAs: "Save as",
  search: "Search",
  seeListing: "See Data Room in Transactions",
  select: "Select",
  selectAll: "Select all",
  selectDiscussion: "Select discussion",
  selectDocuments: "Select documents",
  selectId: "Select ID",
  selection: "Selection",
  selectMemberByUsername: "Select member by username",
  selectRequest: "Select request",
  "service.type": "Service type",
  "serviceRequest.attachments.help":
    "When the service request is related to a vehicle, attachments will be accessible from the vehicle's vault.",
  "serviceRequest.backToRequests": "Back to requests",
  "serviceRequest.closedRequests": "Closed requests",
  "serviceRequest.create": "Create a service request",
  "serviceRequest.form.selectVehicleFirst": "Select a vehicle first",
  "serviceRequest.menu.accept": "Accept request",
  "serviceRequest.menu.cancel": "Cancel request",
  "serviceRequest.menu.complete": "Complete request",
  "serviceRequest.menu.edit": "Edit request",
  "serviceRequest.openRequests": "Open requests",
  "serviceRequest.status": "Status",
  "serviceRequest.status.canceled": "Canceled",
  "serviceRequest.status.completed": "Completed",
  "serviceRequest.status.ongoing": "Ongoing",
  "serviceRequest.status.requested": "Requested",
  "serviceRequest.userNotPartOfOrganization": "Not part of organization",
  settings: "Settings",
  "settings.help.content":
    "In case you need support or have any specific questions about our service please contact [support@driven.world](mailto:support@driven.world)",
  showInterest: "Show interest",
  signUp: "Sign up",
  signUpClaim: "Already a member?",
  size: "Size",
  sortBy: "Sort by",
  "sorting.addedNewest": "Added: newest first",
  "sorting.addedOldest": "Added: oldest first",
  "sorting.crewMembersCountHighest": "Number of crew members: highest first",
  "sorting.crewMembersCountLowest": "Number of crew members: lowest first",
  "sorting.emailAZ": "Email: A-Z",
  "sorting.listedNewest": "Listed: newest first",
  "sorting.listedOldest": "Listed: oldest first",
  "sorting.makeAZ": "Make: A-Z",
  "sorting.nameAZ": "Name: A-Z",
  "sorting.odometerHighest": "Odometer: highest first",
  "sorting.odometerLowest": "Odometer: lowest first",
  "sorting.priceHighest": "Price: highest first",
  "sorting.priceLowest": "Price: lowest first",
  "sorting.productionYearNewest": "Production year: newest first",
  "sorting.productionYearOldest": "Production year: oldest first",
  "sorting.readonlyVehicleCountHighest":
    "Number of readonly vehicles: highest first",
  "sorting.readonlyVehicleCountLowest":
    "Number of readonly vehicles: lowest first",
  "sorting.registeredLatest": "Registered: latest first",
  "sorting.registeredOldest": "Registered: oldest first",
  "sorting.surnameAZ": "Surname: A-Z",
  "sorting.titleAZ": "Title: A-Z",
  "sorting.titleZA": "Title: Z-A",
  "sorting.usernameAZ": "Username: A-Z",
  "sorting.valuationHighest": "Market value: highest first",
  "sorting.valuationLowest": "Market value: lowest first",
  "sorting.vehicleCountHighest": "Number of vehicles: highest first",
  "sorting.vehicleCountLowest": "Number of vehicles: lowest first",
  sortNone: "None",
  specs: "Specifications",
  "specs.aerodynamicsDragCoefficient": "Aerodynamics (Drag coefficient)",
  "specs.aerodynamicsFrontalArea": "Aerodynamics (Frontal area)",
  "specs.back": "Back",
  "specs.batteryCapacity": "Battery capacity",
  "specs.bodyStyle": "Body style",
  "specs.brakesFront": "Brakes front",
  "specs.brakesRear": "Brakes rear",
  "specs.carburetors": "Number of carburetors",
  "specs.cargoVolume": "Cargo volume",
  "specs.chargingTime": "Charging time",
  "specs.clutch": "Clutch type",
  "specs.co2Emissions": "CO2 emissions",
  "specs.colorExterior": "Exterior color",
  "specs.colorInterior": "Interior color",
  "specs.cooling": "Cooling",
  "specs.displacement": "Displacement",
  "specs.doors": "Number of doors",
  "specs.driveTrain": "Drive train type",
  "specs.driveType": "Drive type",
  "specs.empty.readonly": "No specifications provided",
  "specs.engineType": "Engine type",
  "specs.extras": "Extras",
  "specs.frontTrack": "Front track",
  "specs.fuelCapacity": "Fuel capacity",
  "specs.fuelConsumption": "Fuel consumption",
  "specs.fuelInjectors": "Number of fuel injectors",
  "specs.fuelSystem": "Fuel system",
  "specs.fuelType": "Fuel type",
  "specs.gearBox": "Gearbox type",
  "specs.gearBoxConstruction": "Gearbox construction",
  "specs.gearBoxExtra": "Gearbox extra",
  "specs.gears": "Number of gears",
  "specs.grossWeightLimit": "Gross weight limit",
  "specs.groundClearance": "Ground clearance",
  "specs.height": "Height",
  "specs.homologation": "Homologation",
  "specs.hundredTo0": "100-0 km/h",
  "specs.importedFrom": "Imported from",
  "specs.importStatus": "Import status",
  "specs.length": "Length",
  "specs.manufacturedFrom": "Manufactured from",
  "specs.manufacturedUntil": "Manufactured until",
  "specs.maxSpeed": "Top speed",
  "specs.numberElectricEngines": "Number of electric engines",
  "specs.numberOfOwners": "Number of owners",
  "specs.numberProduced": "Units produced",
  "specs.powerBHP": "Brake horsepower",
  "specs.powerHP": "Horsepower",
  "specs.powerKW": "Power output",
  "specs.powerPeak": "Power peak",
  "specs.producedInCountry": "Produced in country",
  "specs.purchasePrice": "Purchase price",
  "specs.putIntoCirculation": "Put into circulation",
  "specs.range": "Range",
  "specs.rearTrack": "Rear track",
  "specs.seats": "Number of seats",
  "specs.tiresFront": "Tires front",
  "specs.tiresRear": "Tires rear",
  "specs.topVehicles": "Top vehicles",
  "specs.torque": "Torque",
  "specs.torquePeak": "Torque peak",
  "specs.turbo": "Turbo",
  "specs.turningCircle": "Turning circle",
  "specs.turningCircleCurbToCurb": "Turning circle (Curb to curb)",
  "specs.turningCircleWallToWall": "Turning circle (Wall to wall)",
  "specs.unladenWeight": "Unladen weight",
  "specs.wheelbase": "Wheelbase",
  "specs.width": "Width",
  "specs.zeroTo100": "0-100 km/h",
  "specs.zeroTo200": "0-200 km/h",
  "specs.zeroTo300": "0-300 km/h",
  startTypingAddress: "Start typing address…",
  startVerification: "Verify Device",
  status: "Status",
  style: "Style",
  subscribe: "Subscribe",
  "subscribe.billing.title": "Billing information",
  "subscribe.error.failed":
    "Subscription couldn't be completed. Try again later.",
  "subscribe.error.fetchTiers":
    "Current plans could not be loaded. Try again later.",
  "subscribe.promoCode.add": "Add promo code",
  "subscribe.promoCode.apply": "Apply",
  "subscribe.selected": "Selected subscription package",
  "subscribe.success": "Subscription completed successfully",
  "subscribe.summary.plan":
    "You will pay <strong>{{total}}</strong> as a base fee every month. The amount will be first charged on <strong>{{renewalDate}}</strong> and will auto-renew until cancelled.",
  "subscribe.summary.planExtension":
    "The charge for the garage slots and collaborator seats will be applied at the end of each monthly billing period according to your current usage on the day of renewal. You will be able to see the upcoming charge prognosis in you subscription settings.",
  "subscribe.summary.title": "Summary",
  subscribeNow: "Subscribe now",
  subscription: "Driven subscription",
  "subscription.amountDue":
    "<strong>Your next invoice according to the current usage: </strong>{{currency}} {{amount}}",
  "subscription.automaticRenewal":
    "<strong>Automatic renewal: </strong>{{date}}",
  "subscription.canceled": "Subscription canceled successfully",
  "subscription.creditCardSetup.error":
    "There was an error setting up billing information. Please try again later.",
  "subscription.error.fetch":
    "Your subscription could not be loaded. Try again later.",
  "subscription.expired":
    "Your subscription is expired since <strong>{{date}}</strong>. Please, <strong>manage your subscription</strong> to continue using Driven.",
  "subscription.expired.short": "No subscription active",
  "subscription.infoUnsubscribing":
    "Subscription gives you unlimited access to Driven garage and our exclusive, subscribers only features such as collaboration and data rooms.\n\nStay in full control, always. We will never share your data with anyone and all your documents are encrypted. Not even we can see them.",
  "subscription.infoUnsubscribing2":
    "Thinking of cancelling? Get in touch and we will find a suitable solution for you and your collection. [info@riven.world](mailto:info@riven.world)",
  "subscription.manage": "Manage subscription",
  "subscription.paymentMethod": "<strong>Payment method: </strong>{{card}}",
  "subscription.quota.additional": "additional",
  "subscription.quota.collaborationSeats": "Collaboration seats",
  "subscription.quota.collaborationSeats.disabled":
    "Upgrade your subscription for Crew Mode",
  "subscription.quota.garageSlots": "Garage slots",
  "subscription.quota.garageSlots.disabled":
    "Upgrade your subscription for more garage slots",
  "subscription.quota.included": "included",
  "subscription.quota.transactionsListings":
    "<strong>{{quotaUsage}}</strong> Transactions Data Rooms left",
  "subscription.quota.transactionsListings.disabled":
    "Upgrade your subscription for Transactions Data Rooms",
  "subscription.quota.usage": "Usage",
  "subscription.renewalCanceled":
    "Your subscription will expire on <strong>{{date}}</strong>. Please, <strong>restore your subscription</strong> to continue using Driven.",
  "subscription.renewalDetailsError":
    "There was an error getting your renewal information. Please try again later.",
  "subscription.renewalIntervalChanged":
    "You requested a change to <strong>{{interval}}</strong> billing. This will be active after the end of your current billing period.",
  "subscription.renewalTierChanged":
    "You requested to downgrade to <strong>{{tier}}</strong>. This will be active after the end of your current billing period.",
  "subscription.subscribe":
    "You have not selected any of our packages yet. Subscribe and enjoy all the benefits now.",
  "subscription.trialPeriod":
    "Your trial period ends in <strong>{{interval}}</strong>.",
  "subscription.trialPeriod.short":
    "Trial ends in <strong>{{interval}}</strong>",
  "subscription.unsubscribed.chargesDetail":
    "The charge for the vehicle slots and collaborator seats will be applied at the end of each monthly billing period according to your current usage on the day of renewal.",
  "subscription.unsubscribed.info":
    "Subscribe and gain unlimited access to Driven garage and our exclusive, subscribers only features such as collaboration and data rooms.\n\nStay in full control, always. We will never share your data with anyone and all your documents are encrypted. Not even we can see them.",
  "subscription.unsubscribed.info2":
    "Driven is completely customizable - you pay only for the number of garage slots and collaborator seats that you use.",
  summary: "Summary",
  surname: "Surname",
  surnameRequired: "Surname is required",
  "system.tag.car_history": "Vehicle history",
  "system.tag.identity": "Identity",
  "system.tag.import": "Import",
  "system.tag.insurance": "Insurance",
  "system.tag.ownership": "Ownership",
  "system.tag.registration": "Registration",
  systemTag: "System tag",
  tag: "Tag",
  tags: "Tags",
  termsAndConditions: "Terms and Conditions",
  "textDetection.error.invalidImageType": "Invalid image type",
  "textDetection.error.passwordProtectedDocument": "Password protected",
  "textDetection.status.failed": "Parsing failed",
  "textDetection.status.finished": "Processing file",
  "textDetection.status.parsing.failed": "Parsing failed",
  "textDetection.status.parsing.succeeded": "History record created",
  "textDetection.status.started": "Processing file",
  "textDetection.status.succeeded": "Applying AI magic",
  tier: "Tier",
  "tier.additional": "Additional",
  "tier.additional.collaboratorSeat": "{{price}} for collaborator seat",
  "tier.additional.vehicleSlot": "{{price}} for vehicle slot",
  "tier.aspiring_collector": "Aspiring Collector",
  "tier.baseSubscription.claim": "$49.95 per month",
  "tier.baseSubscription.title": "Base subscription",
  "tier.collaboratorSeats.claim": "$19.95 per seat",
  "tier.collaboratorSeats.title": "Collaborator seats",
  "tier.collector": "Collector",
  "tier.enthusiast": "Enthusiast",
  "tier.features.collaboration_one": "Collaboration ({{count}} seat included)",
  "tier.features.collaboration_other":
    "Collaboration ({{count}} seats included)",
  "tier.features.collaboration_zero": "Collaboration",
  "tier.features.encryption": "File encryption",
  "tier.features.encryption.description": "Optional end-to-end file encryption",
  "tier.features.includedVehicles_one": "{{count}} vehicle included",
  "tier.features.includedVehicles_other": "{{count}} vehicles included",
  "tier.features.vehicleLimit_one": "{{count}} vehicle slot",
  "tier.features.vehicleLimit_other": "Up to {{count}} vehicle slots",
  "tier.features.vehicleLimit_zero": "No vehicle slots limit",
  "tier.garageSlots.claim_one": "First slot is free",
  "tier.garageSlots.claim_other": "First {{count}} slots are free",
  "tier.garageSlots.claim_zero": "No free slots",
  "tier.garageSlots.tier_1": "$15.95 per slot, for 1-30 slots",
  "tier.garageSlots.tier_2": "$12.95 per slot, for 31-100 slots",
  "tier.garageSlots.tier_3": "$9.95 per slot, for 100+ slots",
  "tier.garageSlots.title": "Garage slots",
  "tier.metered_usage": "Metered Usage",
  "tier.pro": "Pro",
  "tier.pro_collector": "Pro Collector",
  tierExpirationDate: "Tier expiration",
  "tiers.billedAnnually": "billed annually",
  "tiers.billedMonthly": "billed monthly",
  "tiers.cancel": "Cancel",
  "tiers.cancelConfirm":
    "Are you sure you want to cancel your current subscription?",
  "tiers.change": "Change",
  "tiers.downgrade": "Downgrade",
  "tiers.enterprise": "Enterprise",
  "tiers.enterprise.cta": "Book a meeting",
  "tiers.enterprise.subtitle":
    "Contact us to discuss our exclusive custom packages",
  "tiers.enterprise.title": "Looking for a tailored solution?",
  "tiers.month": "month",
  "tiers.note":
    "*Crew mode allows paid subscribers to give other users access to their collection and features according to their active plan. Crew member only accounts are free but do not own allow asset creation and management unless crew member is also a paid subscriber. Requires registration.",
  "tiers.perMonth": "per month",
  "tiers.restore": "Restore",
  "tiers.startTrial": "start trial",
  "tiers.subscribe.disabled": "Your usage is currently over this tier quotas",
  "tiers.title": "Subscription tiers",
  "tiers.upgrade": "Upgrade",
  timeline: "Timeline",
  title: "Title",
  "title.about": "About",
  "title.admin": "Admin",
  "title.admin.concierges": "Concierges",
  "title.admin.layoutScopes": "Layout scopes",
  "title.admin.listings": "Data Rooms",
  "title.admin.usageHistory": "Usage history",
  "title.admin.users": "Users",
  "title.admin.vehicles": "Vehicles",
  "title.careers": "Careers",
  "title.changePassword": "Change password",
  "title.collection.notFound": "Collection not found",
  "title.collector.notFound": "Collector not found",
  "title.consent": "Consent",
  "title.crewInvitationExpired": "Your invite has expired",
  "title.curation.operationNotAllowed": "Operation not allowed",
  "title.dashboard": "Dashboard",
  "title.explore": "Explore",
  "title.explore.collections": "Explore Collections",
  "title.explore.vehicles": "Explore Vehicles",
  "title.garage": "Garage",
  "title.garage.activity": "Activity",
  "title.garage.addCollection": "Add a collection",
  "title.garage.addHistoryRecord.add": "New history record",
  "title.garage.addLocation": "Add a location",
  "title.garage.addVehicle": "Add a vehicle",
  "title.garage.collections": "Collections",
  "title.garage.dashboard": "Dashboard",
  "title.garage.dataRoom": "Data Room",
  "title.garage.dataRoom.activity": "Activity",
  "title.garage.dataRoom.manage": "Manage",
  "title.garage.dataRoom.messages": "Messages",
  "title.garage.dataRooms": "Data Rooms",
  "title.garage.gallery": "Gallery",
  "title.garage.locations": "Locations",
  "title.garage.logBook": "Log Book",
  "title.garage.logBook.odometer": "Odometer",
  "title.garage.logBook.valuation": "Price history",
  "title.garage.messages": "Messages",
  "title.garage.reminders": "Reminders",
  "title.garage.requests": "Requests",
  "title.garage.timeline": "Timeline",
  "title.garage.vault": "Vault",
  "title.garage.vehicles": "Vehicles",
  "title.garage.wishlist": "Wishlist",
  "title.job": "Job",
  "title.job.notFound": "Job not found",
  "title.listing.notFound": "Data Room not found",
  "title.login": "Login",
  "title.maintenance": "Maintenance",
  "title.mfa": "Multi-factor Authentication",
  "title.notFound": "404 - Wheels gone",
  "title.onboarding.actions": "Onboarding: First actions",
  "title.onboarding.details": "Onboarding: Details",
  "title.onboarding.introduction": "Onboarding: Introduction",
  "title.organization.collectors": "Collectors",
  "title.organization.dealers": "Dealers",
  "title.organization.dealerships": "Dealerships",
  "title.organization.locations": "Locations",
  "title.organization.requests": "Requests",
  "title.organization.requests.details": "Details",
  "title.organization.requests.messageBoard": "Message board",
  "title.organization.services": "Services",
  "title.organization.settings": "Settings",
  "title.organization.usageHistory": "Usage history",
  "title.organization.user_management": "User management",
  "title.organization.vehicles": "Vehicles",
  "title.releaseNotes": "Release notes",
  "title.required": "Title required",
  "title.resetPassword": "Reset password",
  "title.sandbox": "Sandbox",
  "title.serviceRequest": "Service request",
  "title.serviceRequest.attachments": "Attachments",
  "title.serviceRequest.messages": "Messages",
  "title.settings": "Settings",
  "title.settings.accountManagement": "Account management",
  "title.settings.accountManagement.subtitle":
    "As a Driven user, you always have full control of your account. You can always perform the actions bellow.",
  "title.settings.collaboration": "Collaboration",
  "title.settings.crew": "Crew",
  "title.settings.curate": "Curate",
  "title.settings.encryption": "Encryption",
  "title.settings.experiments": "Experiments",
  "title.settings.organizations": "Organizations",
  "title.settings.private": "Private data",
  "title.settings.profile": "Profile",
  "title.settings.security": "Security",
  "title.settings.subscription": "Subscription",
  "title.settings.subscription.invoices": "Invoices",
  "title.settings.subscription.membership": "Membership",
  "title.settings.subscription.paymentMethods": "Payment Methods",
  "title.settings.tagManager": "Tag manager",
  "title.settings.tagManager.subtitle":
    "Here you can check the tags and create new ones yourself. You can then use tags to categorize any document you like",
  "title.settings.verification": "Verification",
  "title.signup": "Sign up",
  "title.transactions": "Transactions",
  "title.transactions.dataRoom": "Data Room",
  "title.transactions.dataRooms": "Data Rooms",
  "title.transactions.dataRoomSettings": "Settings",
  "title.transactions.messageBoard": "Message board",
  "title.transactions.negotiations": "Discussions",
  "title.unsubscribe": "Unsubscribe",
  "title.usageHistory": "Usage history",
  "title.vehicle.notFound": "Vehicle not found",
  to: "to",
  toggleTheme: "Dark mode",
  tokenInvalid: "The token you are using has expired",
  toYear: "To year",
  transactions: "Transactions",
  "transactions.dataRoom.externalLinks": "Selected external links",
  "transactions.dataRoom.externalLinks.empty": "No external links selected",
  "transactions.dataRoom.gallery": "Selected gallery medias",
  "transactions.dataRoom.gallery.empty": "No gallery medias selected",
  "transactions.dataRoom.grant.button": "Save changes",
  "transactions.dataRoom.grant.subtitle":
    "You can give granular access to your vehicle data to a potential buyer. This will allow them to see specific section of your Data Room.",
  "transactions.dataRoom.grant.title": "Grant read only access",
  "transactions.dataRoom.negotiation.canceled": "Negotiation was canceled",
  "transactions.dataRoom.negotiation.empty": "Nothing was shared yet",
  "transactions.dataRoom.negotiation.interest":
    "Waiting for seller to accept interest",
  "transactions.dataRoom.specs": "Specifications",
  "transactions.dataRoom.specs.empty": "No specifications",
  "transactions.dataRoom.vault": "Selected vault files",
  "transactions.dataRoom.vault.empty": "No vault files selected",
  "transactions.dataRooms.cta": "Create Data Room",
  "transactions.dataRooms.empty":
    "You did not publish any Data Rooms yet. Create Data Room for a car you would like to offer first.",
  "transactions.fromPrice": "From price",
  "transactions.listings": "Data Rooms",
  "transactions.toPrice": "To price",
  "transactions.transactions": "Transactions",
  transferred: "Transferred",
  transferVehicle: "Transfer vehicle",
  transmission: "Transmission",
  type: "Type",
  unarchiveVehicle: "Unarchive vehicle",
  undo: "Undo",
  unhighlight: "Unhighlight",
  unknownDevice: "Unknown device model",
  unsubscribe: "Unsubscribe",
  "unsubscribe.confirmation":
    "You are about to unsubscribe from receiving marketing emails to <strong>{{email}}</strong>. Do you want to proceed?",
  "unsubscribe.success": "Unsubscribed successfully",
  "unsubscribed.hero.freeVehiclesMaxed":
    "YOU HAVE REACHED THE MAXIMUM FREE VEHICLES ALLOWED\n\n**ADD THE REST OF YOUR COLLECTION**",
  "unsubscribed.hero.title":
    "YOUR CAR COLLECTION, ALL IN ONE PLACE\n\n**DRIVEN GARAGE**",
  "unsubscribed.title": "Try any of our plans, free for 6 months",
  "unsubscribed.usps.badge-check.content":
    "All the owners of the vehicles you find public in Driven have been verified by our team, this is real community.",
  "unsubscribed.usps.badge-check.title": "Verify your ownership",
  "unsubscribed.usps.database.content":
    "We know about how difficult it is to keep all those repair bills and documents in a folder. In Driven you can **centralize all of them in your digital Vault**.Extensive documentation is not just nice to have – it’s the baseline that lets you maintain and increase the value of your collection in the long run. Get rid of your excel spreadsheets and turn your vehicles with ease into fully documented virtual masterpieces. Curate all the information that make your vehicles unique.",
  "unsubscribed.usps.database.title": "Data management in perfection",
  "unsubscribed.usps.flag-checkered.content":
    "Keep up with the current mileage of your vehicle with our digital Odometer, you can easily update it with every awesome trip or race you do as well as keeping record of the event",
  "unsubscribed.usps.flag-checkered.title": "Plan your trips",
  "unsubscribed.usps.vault.content":
    "We know about how difficult it is to keep all those repair bills and documents in a folder. In Driven you can **centralize all of them in your digital Vault**.",
  "unsubscribed.usps.vault.title": "Organize your documents",
  update: "Update",
  updateOdometer: "Update odometer",
  updateVehicleConsignment: "Update vehicle consignment",
  updateVehicleLocation: "Update vehicle location",
  upgrade: "Upgrade",
  upgradeYourSubscriptionToShowInterest:
    "Upgrade you subscription in order to be able to show interest",
  uploadDocuments: "Upload documents",
  uploadEncrypted: "Encrypt and upload",
  uploadError: "Something went wrong while uploading the files",
  uploadImage: "Upload image",
  uploadImages: "Upload images",
  uploadPhotos: "Upload photos",
  uploadVehicle: "Upload a vehicle",
  useAsDefault: "Use as default",
  user: "User",
  "user.crew.active": "Active",
  "user.crew.alert.verification":
    "To invite crew members you need to verify your identity",
  "user.crew.availableSeats": "Active crew members ({{seatsInUse}})",
  "user.crew.content":
    "Your crew has full access to your garage. Acting on your behalf, they can manage your assets and organize your documents, for example. They cannot see your personal data. Their actions can be recorded and audited.",
  "user.crew.empty": "You do not have any crew member yet",
  "user.crew.inactive": "Inactive",
  "user.crew.inactive.security": "2FA is not enabled.",
  "user.crew.inactive.verification": "Verification is not complete.",
  "user.crew.invite": "Crew invitation",
  "user.crew.invite.confirmed": "Invite from {{username}} accepted",
  "user.crew.invite.createNew": "Create new invitation",
  "user.crew.invite.description":
    "Send this link to anyone you would wish to include into your Collaboration service as part of your Crew.",
  "user.crew.invite.expired": "Expired",
  "user.crew.invite.expires": "Expires",
  "user.crew.invite.invalidated": "Invite invalidated",
  "user.crew.invite.new": "New invite",
  "user.crew.invite.sendViaEmail": "Send via email",
  "user.crew.invite.view": "View invite",
  "user.curation.alert.security":
    "To curate you need to enable two-factor authentication",
  "user.curation.alert.subtitle":
    "While acting as a curator, your actions are recorded and can be audited",
  "user.curation.alert.title": "Curating activity is logged",
  "user.curation.alert.verification":
    "To curate you need to verify your identity",
  "user.curation.content":
    "As a crew member, you have full access to another collector's garage. You can act on their behalf to manage assets, organize documents and media, for example. You will not have access to their personal data. While curating, your actions are recorded and can be audited.",
  "user.curation.operationNotAllowed":
    "While acting as a curator, you can manage vehicles and collections but no personal information",
  "user.curation.start": "Start curating",
  "user.curation.withdraw": "Withdraw from crew",
  "user.encryption.ai.info":
    "This level of data privacy comes with a trade-off: our system, including AI tools, cannot access or analyze encrypted files. Consequently, some features, like automatic creation of History Records, will not be available for these files",
  "user.encryption.description":
    "At Driven, the privacy and security of our collectors are of the utmost importance. We employ advanced encryption methods to ensure your data remains confidential and secure. We generate a unique pair of cryptographic keys for you: a public key and a private key using RSA-OAEP, as well as a symmetric key for your data encryption using AES-GCM. <br /><br /> The symmetric key, known as the Data Encryption Key (DEK), is used to efficiently encrypt and decrypt your data. To protect the DEK, we encrypt it with your public key. This means that only your corresponding private key can decrypt the DEK, ensuring that your data remains secure even if the encrypted DEK is intercepted. <br /><br />Your private key is further secured by encrypting it with a key derived from your personal passphrase using AES-GCM. This derived key ensures that even if someone gains access to your encrypted private key, they cannot decrypt it without knowing your passphrase. Importantly, we never store your passphrase or your unencrypted private key in our system.<br /><br />In our storage, we keep only the encrypted versions of your private key and the DEK, along with your public key. This approach means that without your passphrase, it’s practically impossible for anyone to access your decrypted keys or data. <br /><br />When you want to access your encrypted data, you provide your passphrase. With this passphrase, we derive the key needed to decrypt your private key. Once your private key is decrypted, we use it to decrypt the DEK. Finally, the DEK decrypts your data, allowing you to access it securely.<br /><br />This layered encryption process ensures that your data is protected at every step. Even if someone were to gain unauthorized access to our storage, they would be unable to decrypt your data without your unique passphrase. We are committed to maintaining your trust by prioritizing your privacy and security in all aspects of our service.",
  "user.encryption.keys.info":
    "Your keys are set. You can upload encrypted files to vault",
  "user.encryption.passphrase.change": "Change passphrase",
  "user.encryption.passphrase.init": "Initialize passphrase",
  "user.encryption.title": "On device encryption",
  "user.experiments.feature.aiValuation.body":
    "Neural network is used to estimate the market value of your vehicles. This is based on the vehicle's specifications, drivetrain, odometer value and the current market situation.",
  "user.experiments.feature.aiValuation.caption":
    "Valuation estimation is for informative purposes only and might be incorrect. It should not be used as a reference for investment decisions.",
  "user.experiments.feature.aiValuation.title": "Valuation estimation",
  "user.experiments.feature.backlogHistoryRecordParser.body":
    "All files in vaults are processed by a neural network to identify a history record. This is a long running operation and might take some time. You will be notified when draft history records are created.",
  "user.experiments.feature.backlogHistoryRecordParser.caption":
    "This feature requires that data is processed outside Switzerland. By enabling this feature, you agree to the updated terms and conditions.",
  "user.experiments.feature.backlogHistoryRecordParser.title":
    "Parse history record from existing vault files",
  "user.experiments.feature.historyRecordParser.body":
    "Neural network is used to identify a history record from new files uploaded to vault. Records are created as drafts for your review.",
  "user.experiments.feature.historyRecordParser.caption":
    "This feature requires that data is processed outside Switzerland. By enabling this feature, you agree to the updated terms and conditions.",
  "user.experiments.feature.historyRecordParser.title":
    "Parse history record from new vault files",
  "user.experiments.feature.historyRecordParser.vaultAlert.enabled.collector":
    "Experimental feature enabled. All the newly uploaded files will be parsed to identify history records automatically.",
  "user.experiments.feature.historyRecordParser.vaultAlert.enabled.concierge":
    "Collector has enabled an experimental feature. All the newly uploaded files will be parsed to identify history records automatically.",
  "user.experiments.feature.historyRecordParser.vaultAlert.undefined.collector":
    "Enable the <experimentsLink>{{feature}}</experimentsLink> experimental feature to automatically identify history records from newly uploaded files.",
  "user.experiments.feature.invitation.description":
    "Here you can enable or disable experimental features. Features are still in development and may not work as expected.",
  "user.experiments.feature.invitation.title": "Experimental features",
  "user.password.reset.email": "We sent you a link to reset your password",
  "user.password.reset.expired":
    "The token has expired, please request a new one",
  "user.security.mfa.description":
    "You have enabled two-factor authentication for your account. You can select bellow the factor you wish to use. You can always disable this factors after.",
  "user.security.mfa.email.body":
    "Set up your email address to receive the codes",
  "user.security.mfa.email.title": "Email address",
  "user.security.mfa.invitation.cta": "Set extra security",
  "user.security.mfa.invitation.description":
    "The <strong>privacy</strong> and <strong>security</strong> of our collectors is most important for us. For this, <strong>we suggest you to Enable now two-factor authentication</strong> for an even higher level of security for your account. This is really simple.",
  "user.security.mfa.invitation.title":
    "Easily set extra security with 2-Factor authentication",
  "user.security.mfa.otp.body":
    "Set up your authenticator app, we recommend<br /><1>Google Authenticator</1> or <3>Authy</3>",
  "user.security.mfa.otp.title": "Authenticator app",
  "user.security.mfa.webauthn.body":
    "Set up your physical device as an authenticator",
  "user.security.mfa.webauthn.title": "Physical device",
  username: "Username",
  usernameInvalid:
    "Username can only contain letters, numbers, underscores and dashes.",
  users: "Users",
  userTag: "User tag",
  utmCampaign: "UTM Campaign",
  utmMedium: "UTM Medium",
  utmSource: "UTM Source",
  "validation.required": "Required",
  validFrom: "Valid from",
  validUntil: "Valid until",
  valuation: "Market value",
  valuationDate: "Market valuation date",
  value: "Value",
  valueForOdometerInconsistent:
    "This reading is inconsistent with this vehicle's history",
  valueNotNumber: "Value must be a number",
  valueOutsideRange: "Value outside range (0 - 2147483647)",
  variant: "Variant",
  variantPlaceholder: "Trim level (eg LX), package (eg. Sport), etc.",
  vaultEmpty:
    "The Vault will <1>store and manage all the documents</1> of your vehicles. You can already upload the first document.",
  vaultInvitation:
    "The Vault will <1>store and manage all the documents</1> of your vehicle. You can already upload the first document.",
  vehicle: "Vehicle",
  "vehicle.count_one": "{{count}} vehicle",
  "vehicle.count_other": "{{count}} vehicles",
  "vehicle.count.filtered": "Showing {{filtered}} of {{total}} vehicles",
  "vehicle.make.other": "Other",
  "vehicle.make.unknown": "Unknown",
  "vehicle.managedByPartner":
    "This vehicle is managed by <strong>{{title}}</strong>",
  "vehicle.organization.assign": "Assign to organization",
  "vehicle.organization.withdraw": "Withdraw from organization",
  "vehicle.serviceRequest.menu": "Request service",
  "vehicle.serviceRequest.request": "Request",
  "vehicle.serviceRequest.title": "Request a new service",
  "vehicle.status": "Status",
  "vehicle.status.archived": "Archived",
  "vehicle.status.for_sale": "For sale",
  "vehicle.status.for_trade_in": "For trade-in",
  "vehicle.status.listed": "Listed",
  "vehicle.status.private": "Owned",
  "vehicle.status.sold": "Sold",
  "vehicle.status.transferred": "Transferred",
  "vehicle.status.transferring": "Transferring",
  "vehicle.status.under_right_condition_for_sale":
    "Under right condition for sale",
  "vehicle.status.wishlist": "Wishlist",
  "vehicle.step.manageCollections.selected": "You have selected",
  "vehicle.step.manageCollections.title": "Select collections",
  "vehicle.technicalData": "Technical data",
  "vehicle.technicalData.chassisNumber": "Chassis number",
  "vehicle.technicalData.colorCode": "Color code",
  "vehicle.technicalData.engineNumber": "Engine number",
  "vehicle.technicalData.gearboxNumber": "Gearbox number",
  "vehicle.technicalData.serialNumber": "Serial number",
  "vehicle.technicalData.vin": "Vin",
  "vehicle.transfer.claim.button": "Claim vehicle",
  "vehicle.transfer.claim.description":
    "Do you claim this vehicle? If you proceed, the owner will have the opportunity to confirm your account details, then the vehicle will be transferred to your garage.",
  "vehicle.transfer.claim.description.concierge":
    "Do you claim this vehicle for the collector? If you proceed, the owner will have the opportunity to confirm their account details, then the vehicle will be transferred to their garage.",
  "vehicle.transfer.confirm.description":
    "Do you want to confirm the transfer to {{username}}?",
  "vehicle.transfer.waiting.owner.description":
    "The owner was notified that the vehicle was claimed. After they confirm the details of the intended recipient, the vehicle will be transferred to their garage.",
  "vehicle.transfer.waiting.target.description":
    "We are waiting for the new potential owner to claim the vehicle. When they do, you will be notified and will be able to confirm their personal details before completing the transfer.",
  "vehicle.value": "Market value",
  "vehicle.value.insurance": "Insurance value",
  "vehicle.value.purchase": "Purchase price",
  "vehicle.value.sale": "Sale price",
  "vehicle.value.taxable": "Taxable value",
  "vehicle.vehicleData": "Vehicle data",
  "vehicle.vehicleData.condition": "Condition",
  "vehicle.vehicleData.currentlyRegistered": "Currently registered",
  "vehicle.vehicleData.currentlyRegisteredCountry":
    "Currently registered country",
  "vehicle.vehicleData.currentlyRegisteredDate": "Currently registered date",
  "vehicle.vehicleData.firstRegistration": "First registration",
  "vehicle.vehicleData.firstRegistrationCountry": "First registration country",
  "vehicle.vehicleData.firstRegistrationDate": "First registration date",
  "vehicle.vehicleData.homologation": "Homologation",
  "vehicle.vehicleData.homologationDate": "Homologation date",
  "vehicle.vehicleData.importStatus": "Import status",
  "vehicle.vehicleData.importStatusDate": "Import status date",
  "vehicle.vehicleData.insuranceTitle": "Insurance title",
  "vehicle.vehicleData.insured": "Insured",
  "vehicle.vehicleData.insuredDate": "Insured date",
  "vehicle.vehicleData.lastInspection": "Last vehicle inspection",
  "vehicle.vehicleData.lastInspectionDate": "Last inspection date",
  "vehicle.vehicleData.numberPlate": "Number plate",
  "vehicle.vehicleData.tyres": "Tyres",
  "vehicle.vehicleData.tyres.description": "(year of production/DOT)",
  "vehicle.vehicleData.veteranDate": "Veteran date",
  vehicleCreated: "Vehicle created",
  vehicleNotFound: "Vehicle not found",
  vehicles: "Vehicles",
  version: "Version: {{version}}",
  videos: "Videos",
  viewLess: "View less",
  viewLocation: "View location",
  viewLog: "View log",
  viewLogbook: "View Logbook",
  viewMore: "View more",
  vin: "VIN",
  visibility: "Visibility",
  walkThrough: "Walk through",
  walkThroughUrl: "Walk through URL",
  warehouse: "Warehouse",
  website: "Website",
  welcome: "Welcome",
  welcomeBack: "Welcome back",
  wishlist: "Wishlist",
  "wishlist.cta": "Add to wishlist",
  "wishlist.empty": "Your wishlist is empty",
  "wishlist.yearFrom": "Before {{year}}",
  "wishlist.yearTo": "After {{year}}",
  withdraw: "Withdraw",
  withdrawInterest: "Withdraw interest",
  year: "Year",
  yearFrom: "From year",
  yearTo: "To year",
  yes: "Yes",
  yesDisable: "yes, disable",
};

export default translations;
